import YLD_HIST from './data/seibro-hist.js';

"use strict";
let LAST = null;

/* ---------- helpers ---------- */
const won = n => Math.round(n).toLocaleString("ko-KR");
const R = n => Math.round(n);
function pad(x){return String(x).padStart(2,"0");}
function parseDate(v){const [y,m,d]=v.split("-").map(Number);return new Date(y,m-1,d);}
/* 날짜 문자열 유효성: 빈값은 ""(미입력), 형식/존재하지 않는 날짜(2026-02-31 등)는 사유 반환 */
function dateError(v){
  if(v==null||String(v).trim()==="") return "";
  const m=/^(\d{4})-(\d{1,2})-(\d{1,2})$/.exec(String(v).trim());
  if(!m) return "형식이 올바르지 않습니다 (YYYY-MM-DD)";
  const y=+m[1],mo=+m[2],d=+m[3], dt=new Date(y,mo-1,d);
  if(dt.getFullYear()!==y||dt.getMonth()!==mo-1||dt.getDate()!==d) return "존재하지 않는 날짜입니다";
  return "";
}
function fmtDate(dt){return `${dt.getFullYear()}.${pad(dt.getMonth()+1)}.${pad(dt.getDate())}`;}
function addMonths(dt,m){
  const d=new Date(dt.getTime()); const day=d.getDate();
  d.setDate(1); d.setMonth(d.getMonth()+m);
  const dim=new Date(d.getFullYear(),d.getMonth()+1,0).getDate();
  d.setDate(Math.min(day,dim)); return d;
}
function addDays(dt,n){const d=new Date(dt.getTime());d.setDate(d.getDate()+n);return d;}
function daysBetween(a,b){return Math.round((b-a)/86400000);}
function monthsFloor(a,b){ // a→b 사이 '완전히 경과한' 개월수 (일 미달분은 버림)
  if(b<a) return 0;
  let m=(b.getFullYear()-a.getFullYear())*12+(b.getMonth()-a.getMonth());
  if(b.getDate()<a.getDate()) m--;
  return Math.max(0,m);
}
function dayInMonth(y,m,day){ // m: 0-base, day 넘치면 말일
  const dim=new Date(y,m+1,0).getDate(); return new Date(y,m,Math.min(day,dim));
}

/* 할인율 산정: 신용등급별 만기 수익률 → 리스기간 선형보간 (SEIBRO 회사채 무보증 공모) */
const YLD_MATS=[3,6,9,12,36,60,120,240];                 // 개월
const YLD_IDS=["y3","y6","y9","y12","y36","y60","y120","y240"];
const YLD={   /*SEIBRO-YLD*/ // 20250522 / SEIBRO 무보증 공모 회사채(%) — seibro_crawl.py --patch 로 갱신
  "AAA":[2.71,2.69,2.63,2.6,2.76,2.9,3.31,3.66],
  "AA+":[2.73,2.73,2.7,2.65,2.83,2.96,3.63,4.05],
  "AA0":[2.75,2.74,2.71,2.67,2.86,3.03,3.97,4.62],
  "AA-":[2.77,2.76,2.74,2.7,2.9,3.13,4.33,5.16],
  "A+":[2.83,2.85,2.86,2.9,3.25,3.8,4.91,5.6],
  "A0":[2.94,2.96,3.0,3.05,3.51,4.25,5.37,6.03],
  "A-":[3.15,3.2,3.27,3.32,3.95,4.85,5.88,6.58],
  "BBB+":[3.59,3.96,4.27,4.44,6.28,6.73,7.32,7.95],
  "BBB0":[3.97,4.46,4.85,5.11,7.33,7.78,8.43,9.12],
  "BBB-":[4.65,5.26,5.79,6.11,8.69,9.2,9.86,10.55],
};/*END-YLD*/
const YLD_DATE=/*YLD_DATE*/"2025-05-22"/*END-YLD_DATE*/;   // 내장 등급표 기준일 (seibro_crawl.py --patch 로 갱신)
let yldDateLive=YLD_DATE;                                  // SEIBRO 자동 갱신 시 최신 기준일로 대체

/* 내장 과거 수익률 (2020~) — seibro_batch.py 로 주입 / {YYYYMMDD:[[3M..20Y]×10등급]} (등급순서 아래) */
/* YLD_HIST 는 data/seibro-hist.js 에서 import (scripts/inject_hist.py 가 갱신) */
const YLD_HIST_GRADES=["AAA","AA+","AA0","AA-","A+","A0","A-","BBB+","BBB0","BBB-"];
let _histKeys=null;
function _histKeysSorted(){ if(!_histKeys) _histKeys=Object.keys(YLD_HIST).sort(); return _histKeys; }
function histPrevDay(ymd){                       // "YYYYMMDD" → 하루 전 "YYYYMMDD"
  const p=new Date(+ymd.slice(0,4),+ymd.slice(4,6)-1,+ymd.slice(6,8)-1);
  return `${p.getFullYear()}${pad(p.getMonth()+1)}${pad(p.getDate())}`;
}
function histLookup(ymd){                         // 내장표 조회: 없으면 직전 영업일로 폴백 / 범위밖이면 null
  const keys=_histKeysSorted();
  if(!keys.length || ymd<keys[0] || ymd>keys[keys.length-1]) return null;
  let d=ymd;
  for(let i=0;i<15;i++){
    const arrs=YLD_HIST[d];
    if(arrs){ const g={}; YLD_HIST_GRADES.forEach((k,ix)=>{ if(arrs[ix]) g[k]=arrs[ix]; }); return {grades:g, used:d}; }
    d=histPrevDay(d);
  }
  return null;
}
const ymd2disp=s=>s.replace(/(\d{4})(\d{2})(\d{2})/,"$1-$2-$3");
function applyHistDate(){                          // [기준일자 수익률 적용] — 내장표에서 즉시 (서버 불필요)
  const out=document.getElementById("ipOut");
  const date=ydBaseDate();
  if(!date){ out.textContent="기준일자(리스개시일 또는 직접입력)를 YYYY-MM-DD로 입력하세요."; return; }
  const hit=histLookup(date);
  if(!hit){
    const keys=_histKeysSorted();
    out.textContent = keys.length
      ? `${ymd2disp(date)}는 내장 표 범위(${ymd2disp(keys[0])} ~ ${ymd2disp(keys[keys.length-1])}) 밖입니다. 만기별 수익률을 아래 표에 직접 입력하세요.`
      : "내장 과거표가 없습니다. 만기별 수익률을 아래 표에 직접 입력하세요.";
    return;
  }
  Object.keys(hit.grades).forEach(k=>{ YLD[k]=hit.grades[k]; });
  yldDateLive=ymd2disp(hit.used);
  const fb = hit.used!==date ? ` (기준일 ${ymd2disp(date)}는 주말/공휴일 → 직전 영업일 ${ymd2disp(hit.used)} 적용)` : "";
  const rt=document.getElementById("ipRating").value;
  if(rt&&YLD[rt]){ loadRating(); if(fb) out.textContent+=fb; }
  else out.textContent=`${ymd2disp(hit.used)} 기준 수익률 반영됨${fb} / 신용등급을 선택하세요`;
}
function ydModeChange(){
  document.getElementById("ydCustomWrap").style.display =
    document.getElementById("ydMode").value==="custom" ? "" : "none";
}
function ydBaseDate(){                                     // 기준일자: 리스개시일(기본) 또는 이용자선택
  const mode=document.getElementById("ydMode").value;
  const src=mode==="custom" ? document.getElementById("ydDate").value
                            : document.getElementById("startDate").value;
  const d=src.replace(/\D/g,"");
  return d.length===8?d:"";
}
/* 내장 YTM에서 (기준일/신용등급/리스기간) → 선형보간 연 할인율(%) / 불가 시 null (엑셀 일괄 가져오기용) */
function ytmRate(dateStr, grade, termMonths){
  const ymd=String(dateStr||"").replace(/\D/g,"");
  if(ymd.length!==8 || !grade || !(termMonths>=1)) return null;
  const hit=histLookup(ymd);
  if(!hit || !hit.grades[grade]) return null;
  const arr=hit.grades[grade], pts=[];
  YLD_MATS.forEach((m,i)=>{ if(arr[i]!=null && arr[i]!=="") pts.push([m,+arr[i]]); });
  if(!pts.length) return null;
  const T=termMonths; let r;
  if(T<=pts[0][0]) r=pts[0][1];
  else if(T>=pts[pts.length-1][0]) r=pts[pts.length-1][1];
  else for(let i=0;i<pts.length-1;i++){ const [m1,r1]=pts[i],[m2,r2]=pts[i+1];
    if(T>=m1&&T<=m2){ r=r1+(r2-r1)*(T-m1)/(m2-m1); break; } }
  return r==null?null:+r.toFixed(4);
}
async function fetchSeibro(){
  const out=document.getElementById("ipOut"), btn=document.getElementById("btnSeibro");
  const date=ydBaseDate();                                 // 기준일자 미입력 시 최근 영업일
  out.textContent=`SEIBRO에서 ${date?date.replace(/(\d{4})(\d{2})(\d{2})/,"$1-$2-$3"):"최근 영업일"} 수익률 가져오는 중... (10~30초)`;
  btn.disabled=true;
  try{
    const r=await fetch("http://127.0.0.1:8899/yields"+(date?"?date="+date:""));
    const j=await r.json();
    if(!j.ok) throw new Error("no data");
    Object.keys(j.yields).forEach(k=>{ YLD[k]=j.yields[k]; });
    yldDateLive = date ? date.replace(/(\d{4})(\d{2})(\d{2})/,"$1-$2-$3") : "최근 영업일";
    const rt=document.getElementById("ipRating").value;
    if(rt&&YLD[rt]) loadRating();
    else out.textContent=`SEIBRO ${yldDateLive} 수익률 반영됨 / 신용등급을 선택하세요`;
  }catch(e){
    out.textContent = e.message==="no data"
      ? "데이터를 가져오지 못했습니다. 한 번 더 눌러보세요. (계속 실패하면 주말/공휴일 - 직전 영업일로 시도)"
      : "갱신 실패: 서버가 꺼져 있습니다. '수익률서버' 바로가기를 먼저 실행하세요.";
  }
  btn.disabled=false;
}
function loadRating(){
  const rt=document.getElementById("ipRating").value;
  if(!rt) return;                                   // '직접 입력' → 현재 값 유지
  const arr=YLD[rt];
  if(arr){
    arr.forEach((v,i)=>{ document.getElementById(YLD_IDS[i]).value=v; });
    document.getElementById("ipOut").textContent=`${rt} 등급 수익률 로드됨 (${yldDateLive} 기준)`;
  }else{
    YLD_IDS.forEach(id=>{ document.getElementById(id).value=""; });
    document.getElementById("ipOut").textContent=`${rt} 등급은 내장 예시값이 없습니다. SEIBRO 수치를 아래 표에 직접 입력하세요.`;
  }
}
function interp(){
  const T=+document.getElementById("termMonths").value;
  if(!(T>=1)){ document.getElementById("ipOut").textContent="리스기간(개월)을 먼저 입력하세요."; return; }
  const pts=[];
  YLD_MATS.forEach((m,i)=>{ const v=document.getElementById(YLD_IDS[i]).value; if(v!=="") pts.push([m,+v]); });
  if(!pts.length){ document.getElementById("ipOut").textContent="만기별 수익률을 1개 이상 입력하세요."; return; }
  let r, note;
  if(T<=pts[0][0]){ r=pts[0][1]; note=`${pts[0][0]}개월 이하 → ${pts[0][0]}개월 수익률 적용`; }
  else if(T>=pts[pts.length-1][0]){ r=pts[pts.length-1][1]; note=`${pts[pts.length-1][0]}개월 이상 → 최장만기 수익률 적용`; }
  else for(let i=0;i<pts.length-1;i++){ const [m1,r1]=pts[i],[m2,r2]=pts[i+1];
    if(T>=m1&&T<=m2){ r=r1+(r2-r1)*(T-m1)/(m2-m1); note=`${m1}~${m2}개월 보간`; break; } }
  document.getElementById("rate").value=+r.toFixed(4);
  const rt=document.getElementById("ipRating").value;
  document.getElementById("ipOut").textContent=`${rt?rt+" / ":""}${T}개월 → 연 ${r.toFixed(4)}% 적용 (${note})`;
}

/* ---------- core ---------- */
function calc(inp){
  const {start,termMonths,report,payment,firstPay,lastPay,periodMonths,timing,annualRate,rateConv,
         payDay,firstPayDate,deposit,idc,incentive,prepaid,restore,terminateDate,termPenalty}=inp;
  const ppy = 12/periodMonths;
  const i = annualRate===0 ? 0
          : rateConv==="effective" ? Math.pow(1+annualRate,1/ppy)-1
          : annualRate/ppy;
  // 회차 수: 완전회차(floor) + 자투리 부분회차 (리스기간이 지급주기의 배수가 아닐 때)
  const nFull = Math.floor(termMonths/periodMonths);
  const stubM = termMonths - nFull*periodMonths;              // 마지막 자투리 개월 (0이면 정확히 떨어짐)
  const n = nFull + (stubM>0 ? 1 : 0);
  const endDate = addDays(addMonths(start,termMonths),-1);   // 리스종료일

  // 회차별 기간길이(개월) / 기간이율 / 원점 기준 경과기간(주기 단위) — 자투리는 부분기간
  const lenM  = Array.from({length:n}, (_,j)=> (j<nFull? periodMonths : stubM));
  const plen  = lenM.map(L=> L/periodMonths);                 // 회차 길이(주기 대비, 완전회차=1)
  const ij    = plen.map(pl=> Math.pow(1+i,pl)-1);            // 회차별 이율(자투리 = 부분기간 이율)
  const tEnd=[]; { let a=0; for(let j=0;j<n;j++){ a+=plen[j]; tEnd[j]=a; } }
  const tStart = tEnd.map((t,j)=> t-plen[j]);                 // 원점~회차 시작 경과기간
  const totalPeriods = termMonths/periodMonths;               // 전체기간(주기 단위)

  // 회차별 리스료 (첫 회차 / 마지막 회차 오버라이드, 자투리는 기본 안분)
  const pays = Array(n).fill(payment);
  if(firstPay!=null) pays[0]=firstPay;
  if(stubM>0 && lastPay==null) pays[n-1]=R(payment*plen[n-1]);   // 자투리 기본: 정기료 안분(추정)
  if(lastPay!=null && n>1) pays[n-1]=lastPay;
  const stub = stubM>0 ? {months:stubM, pay:pays[n-1], autoProrated:(lastPay==null)} : null;

  // 리스부채(현재가치) — 실제 지급시점(경과기간)으로 할인
  let pv=0;
  if(timing==="due"){ pays.forEach((p,j)=> pv += p/Math.pow(1+i,tStart[j])); }
  else { pays.forEach((p,j)=> pv += p/Math.pow(1+i,tEnd[j])); }
  const liability0 = R(pv);

  // 임차보증금 현재가치 (리스 전체기간 말에 반환)
  const depositPV = deposit>0 ? R(deposit/Math.pow(1+i,totalPeriods)) : 0;
  const depositDisc = deposit - depositPV;   // 할인차금 → 사용권자산 가산

  // 사용권자산 취득원가
  const rou = liability0 + idc + prepaid - incentive + restore + depositDisc;

  // 회차 일자 산출 / 지급일 미입력 시 매월 말일 지급 (99 → dayInMonth가 말일로 클램프)
  const pd = payDay || 99;
  const fp = firstPayDate && !isNaN(firstPayDate.getTime()) ? firstPayDate : null;   // 첫 납입일 지정 여부
  function payDateOf(k){ // k: 1-base 지급 회차
    if(timing==="due" && k===1) return new Date(start.getTime());
    if(fp){   // 첫 납입일 지정 → 그 날짜를 앵커로 이후 회차 자동 (후급=1회차, 선급=개시일 다음 회차 기준)
      const seq0 = timing==="due" ? k-2 : k-1;
      return dayInMonth(fp.getFullYear(), fp.getMonth()+seq0*periodMonths, fp.getDate());
    }
    const seq = timing==="due" ? k-1 : k;   // 개시일 이후 몇 번째 지급일인지
    // 개시일이 속한 달의 지급일이 개시일보다 뒤면 그 달부터 시작
    let base = dayInMonth(start.getFullYear(), start.getMonth(), pd);
    let offset = base > start ? seq-1 : seq;
    let d = dayInMonth(start.getFullYear(), start.getMonth()+offset*periodMonths, pd);
    // 마지막 회차: 후급은 리스종료일 표기(예시 방식), 선급은 종료일 초과 시에만 클램프
    if(k===n) d = (timing!=="due" || d>endDate) ? endDate : d;
    return d;
  }

  // 상각표
  const rows=[]; let bal=liability0;
  const per12 = Math.round(12/periodMonths);  // 12개월 내 회차 수
  for(let p=1;p<=n;p++){
    const begin=bal; const pay=pays[p-1]; const ip=ij[p-1]; let interest,after;
    if(timing==="due"){ const base=begin-pay; interest=R(base*ip); after=base+interest; }
    else { interest=R(begin*ip); after=begin+interest-pay; }
    if(p===n && timing!=="due"){ interest=R(pay-begin); after=0; } // 단수차 조정
    bal=after;
    // 유동 = 향후 12개월 지급 리스료의 현재가치 (엑셀 H열 로직)
    let cur=0;
    if(n-p<=per12) cur=R(after);   // 잔여기간 12개월 이내 → 전액 유동
    else { for(let j=p+1;j<=p+per12;j++) cur += pays[j-1]/Math.pow(1+i,j-p); cur=R(cur); }
    const payDate = payDateOf(p);
    // 기간말: 후급 = 지급일 / 선급 = 다음 지급일 전날 (마지막 회차는 리스종료일)
    const intDate = timing==="due" ? (p<n ? addDays(payDateOf(p+1),-1) : endDate) : payDate;
    rows.push({ p, begin, intDate, payDate,
      interest, pay, principal:pay-interest, end:after, cur, noncur:R(after)-cur });
  }
  if(rows.length){ rows[rows.length-1].end=0; rows[rows.length-1].cur=0; rows[rows.length-1].noncur=0; }

  // 개시시점 유동/비유동
  let cur0=0;
  {
    const from = timing==="due"?2:1, to = timing==="due"?per12+1:per12;
    for(let j=from;j<=Math.min(to,n);j++) cur0 += pays[j-1]/Math.pow(1+i, timing==="due"?tStart[j-1]:tEnd[j-1]);
    if(timing==="due") cur0 += pays[0];  // 개시일 즉시 지급분
    cur0=R(cur0); if(cur0>liability0) cur0=liability0;
  }

  // 감가상각 (정액)
  // 감가상각(정액): 회차 균등이 아니라 기간(개월) 비례 — 자투리 회차는 짧은 만큼만
  const rouPerMonth = rou/termMonths;
  { let acc=0; rows.forEach((r,idx)=>{ r.dep = idx===n-1 ? R(rou-acc) : R(rouPerMonth*lenM[idx]); acc+=r.dep; }); }

  // 보증금 유효이자 (매기 이자수익 전입: PV → 명목액 도달) / depBal=기말 장부금액, depCash=현금수령액
  if(deposit>0){
    let db=depositPV;
    rows.forEach((r,idx)=>{
      r.depInt = idx===n-1 ? deposit-db : R(db*ij[idx]);
      db += r.depInt; r.depBal=db; r.depCash=0;
    });
  } else rows.forEach(r=>{r.depInt=0;r.depBal=0;r.depCash=0;});

  // 결산/해지 기준일: 중도 해지일이 '보고일 이전'일 때만 그날까지 인식 (미래 해지일은 아직 미발생)
  const _td = (terminateDate && !isNaN(terminateDate.getTime())) ? terminateDate : null;
  const termD = (_td && _td<=report) ? _td : null;
  const settleDate = termD || report;

  // 기준일까지 완료 회차
  let complete=0;
  for(let p=1;p<=n;p++){ if(rows[p-1].intDate<=settleDate) complete++; else break; }

  // 진행중(부분) 기간 — 월할 결산 (상각표대로: 완전히 경과한 개월수만 반영, 일 미달분은 버림)
  let partial=null;
  if(complete<n){
    const cur=rows[complete];
    const pStart = complete>0 ? addDays(rows[complete-1].intDate,1) : new Date(start.getTime());
    const pEnd = cur.intDate;
    if(settleDate>=pStart && settleDate<pEnd){
      const frac=Math.max(0,Math.min(1, monthsFloor(pStart,settleDate)/periodMonths));
      if(frac>0) partial={ frac, interest:R(cur.interest*frac), dep:R(cur.dep*frac), depInt:R(cur.depInt*frac) };
    }
  }

  // 중도 해지 정산값 (완전 해지)
  let term=null;
  if(termD){
    const liab=(complete? rows[complete-1].end : liability0)+(partial?partial.interest:0);   // 해지일 리스부채 잔액
    const cumDep=rows.slice(0,complete).reduce((s,r)=>s+r.dep,0)+(partial?partial.dep:0);
    const cumDepInt=rows.slice(0,complete).reduce((s,r)=>s+r.depInt,0)+(partial?partial.depInt:0);
    const rouBook=rou-cumDep;                          // 해지일 사용권자산 장부금액
    const penalty=termPenalty||0;
    const gainLoss=liab-rouBook-penalty;               // + 이익 / − 손실
    const depositBook=deposit>0?depositPV+cumDepInt:0; // 해지일 임차보증금 장부금액
    const depositDiff=deposit>0?deposit-depositBook:0; // 반환(명목)−장부 = 잔여 할인 → 이자수익
    term={date:termD, liab, cumDep, rouBook, penalty, gainLoss, depositBook, depositDiff};
  }
  return {inp,i,n,liability0,rou,rows,complete,partial,depositPV,depositDisc,cur0,endDate,pays,settleDate,term,stub};
}

/* ---------- render ---------- */
/* 금액 입력 콤마 포맷 & 파싱 */
function fmtMoney(el){
  const cur=el.value, dot=cur.endsWith(".");
  const num=cur.replace(/[^\d]/g,"");
  el.value = num==="" ? "" : (+num).toLocaleString("ko-KR")+(dot?".":"");
}
function clampDay(el){
  el.value = el.value.replace(/[^\d]/g,"");
  if(el.value!==""){ let v=Math.min(31,Math.max(1,+el.value)); el.value=v; }
}
function fmtDateInput(el){                     // YYYY-MM-DD 자동 마스크 (4자리 후 월로 자동 이동)
  const d=el.value.replace(/\D/g,"").slice(0,8);
  let out=d.slice(0,4);
  if(d.length>4) out+="-"+d.slice(4,6);
  if(d.length>6) out+="-"+d.slice(6,8);
  el.value=out;
}
document.querySelectorAll("input.money").forEach(el=>{
  fmtMoney(el);                               // 초기값 콤마 표시
  el.addEventListener("input",()=>fmtMoney(el));
});
document.querySelectorAll("input.dt").forEach(el=>{
  fmtDateInput(el);
  el.addEventListener("input",()=>fmtDateInput(el));
});
function pickDate(id){                          // 📅 → 네이티브 달력 열기
  const t=document.getElementById(id), p=document.getElementById(id+"_p");
  const d=t.value.replace(/\D/g,"");
  if(d.length===8) p.value=`${d.slice(0,4)}-${d.slice(4,6)}-${d.slice(6,8)}`;
  try{ p.showPicker(); }catch(e){ p.focus(); p.click(); }
}
function syncDate(id){                          // 달력 선택값 → 텍스트칸 반영
  const t=document.getElementById(id), p=document.getElementById(id+"_p");
  if(p.value) t.value=p.value;
}

/* 입력 → calc 인자 (get: id→문자열값 / 화면 DOM과 저장된 리스 목록이 공유) */
function buildInp(get){
  const s=id=>get(id)==null?"":String(get(id));
  const money=id=>+s(id).replace(/,/g,"")||0;
  const moneyN=id=>{const v=s(id).replace(/,/g,""); return v===""?null:+v;};
  const numN=id=>{const v=s(id); return v===""?null:+v;};
  return {
    assetName:s("assetName").trim(),
    start:parseDate(s("startDate")),
    report:parseDate(s("reportDate")),
    termMonths:+s("termMonths"),
    payment:money("payment"),
    firstPay:moneyN("firstPay"),
    lastPay:moneyN("lastPay"),
    periodMonths:+s("freq"),
    timing:s("timing"),
    payDay:numN("payDay"),
    firstPayDate:(()=>{ const v=s("firstPayDate"); const d=parseDate(v); return v&&!isNaN(d.getTime())?d:null; })(),
    annualRate:(+s("rate"))/100,
    rateConv:s("rateConv"),
    deposit:money("deposit"),
    idc:money("idc"),
    incentive:money("incentive"),
    prepaid:money("prepaid"),
    restore:money("restore"),
    terminateDate:(()=>{ const v=s("terminateDate"); const d=parseDate(v); return v&&!isNaN(d.getTime())?d:null; })(),
    termPenalty:money("termPenalty"),
  };
}

function run(){
  const g=id=>document.getElementById(id);
  const gv=id=>g(id).value;
  const err=msg=>{ document.getElementById("out").innerHTML=`<div class="note" style="border-color:#f0b100;background:#fffbeb;color:#92400e;">${msg}</div>`; };
  // #5 존재하지 않는 날짜 차단 (2026-02-31 등이 조용히 3월로 보정되는 것 방지)
  for(const [id,lab] of [["startDate","리스개시일"],["reportDate","보고기간 종료일"],["firstPayDate","첫 납입일"],["terminateDate","중도해지일"]]){
    const e=dateError(gv(id)); if(e){ err(`${lab} 날짜가 ${e}.`); return; }
  }
  const inp=buildInp(id=>g(id).value);
  if(isNaN(inp.start.getTime())||isNaN(inp.report.getTime())){ err("리스개시일과 보고기간 종료일을 YYYY-MM-DD 형식으로 입력하세요."); return; }
  if(!(inp.termMonths>=1)||!(inp.payment>0)||!(inp.annualRate>=0&&g("rate").value!=="")){ document.getElementById("out").innerHTML='<div class="note">리스기간/정기리스료/연 할인율을 입력하세요.</div>'; return; }
  if(inp.report<inp.start){ err("보고기간 종료일이 리스개시일보다 빠릅니다."); return; }
  // #6 날짜 상호 선후관계 검증
  const endDate=addDays(addMonths(inp.start,inp.termMonths),-1);   // 리스종료일
  if(inp.firstPayDate){
    if(inp.firstPayDate<inp.start){ err("첫 납입일이 리스개시일보다 빠릅니다."); return; }
    if(inp.firstPayDate>endDate){ err(`첫 납입일이 리스종료일(${fmtDate(endDate)})보다 늦습니다.`); return; }
  }
  if(inp.terminateDate){
    if(inp.terminateDate<inp.start){ err("중도해지일이 리스개시일보다 빠릅니다."); return; }
    if(inp.terminateDate>endDate){ err(`중도해지일이 리스종료일(${fmtDate(endDate)})보다 늦습니다.`); return; }
  }
  const m=calc(inp); LAST=m;
  document.getElementById("out").innerHTML = view(m);
}

function jeBlock(dateStr, memo, lines){
  const rows = lines.map(l=>`<tr>
    <td class="acc ${l.side==='dr'?'dr':'cr'} ${l.side==='cr'?'indent':''}">${l.side==='dr'?'(차)':'(대)'} ${l.acc}</td>
    <td class="${l.side==='dr'?'dr':''}">${l.side==='dr'?won(l.amt):''}</td>
    <td class="${l.side==='cr'?'cr':''}">${l.side==='cr'?won(l.amt):''}</td>
  </tr>`).join("");
  return `<div class="je"><div class="jehd"><span class="date">${dateStr}</span><span class="memo">${memo}</span></div>
    <table><thead><tr><th>계정과목</th><th>차변</th><th>대변</th></tr></thead><tbody>${rows}</tbody></table></div>`;
}

/* 개시일(step1)/결산일(step3) 분개 — 화면과 엑셀이 공유 */
function buildJournal(m){
  const {inp,liability0,rou,rows,complete,partial,depositPV,pays,settleDate,term}=m;
  const sd=settleDate||inp.report;
  const totDep=rows.slice(0,complete).reduce((s,r)=>s+r.dep,0)+(partial?partial.dep:0);
  const totInt=rows.slice(0,complete).reduce((s,r)=>s+r.interest,0)+(partial?partial.interest:0);
  const totDepInt=rows.slice(0,complete).reduce((s,r)=>s+r.depInt,0)+(partial?partial.depInt:0);
  let payTotal=0;
  rows.forEach((r,idx)=>{ if(r.payDate<=sd && !(inp.timing==="due"&&idx===0)) payTotal+=r.pay; });
  const E=[];
  const cl=[{side:"dr",acc:"사용권자산",amt:rou}];
  if(inp.deposit>0) cl.push({side:"dr",acc:"임차보증금(현재가치)",amt:depositPV});
  if(inp.incentive>0) cl.push({side:"dr",acc:"현금(리스인센티브 수취)",amt:inp.incentive});
  cl.push({side:"cr",acc:"리스부채",amt:liability0});
  if(inp.deposit>0) cl.push({side:"cr",acc:"현금(임차보증금 지급)",amt:inp.deposit});
  if(inp.idc>0) cl.push({side:"cr",acc:"현금(리스개설직접원가)",amt:inp.idc});
  if(inp.prepaid>0) cl.push({side:"cr",acc:"선급리스료",amt:inp.prepaid});
  if(inp.restore>0) cl.push({side:"cr",acc:"복구충당부채",amt:inp.restore});
  E.push({step:1,date:inp.start,memo:"사용권자산/리스부채 최초인식"+(inp.deposit>0?" (보증금 현재가치 평가 포함)":""),lines:cl});
  if(inp.timing==="due") E.push({step:1,date:inp.start,memo:"제1회 리스료 지급(선급)",lines:[{side:"dr",acc:"리스부채",amt:pays[0]},{side:"cr",acc:"현금",amt:pays[0]}]});
  if(payTotal>0) E.push({step:3,date:sd,memo:"리스료 지급액",lines:[{side:"dr",acc:"리스부채",amt:payTotal},{side:"cr",acc:"현금",amt:payTotal}]});
  if(totInt>0) E.push({step:3,date:sd,memo:"리스부채 이자비용",lines:[{side:"dr",acc:"이자비용",amt:totInt},{side:"cr",acc:"리스부채",amt:totInt}]});
  if(totDep>0) E.push({step:3,date:sd,memo:"사용권자산 감가상각비",lines:[{side:"dr",acc:"감가상각비",amt:totDep},{side:"cr",acc:"감가상각누계액",amt:totDep}]});
  if(totDepInt>0) E.push({step:3,date:sd,memo:"임차보증금 이자수익",lines:[{side:"dr",acc:"임차보증금",amt:totDepInt},{side:"cr",acc:"이자수익",amt:totDepInt}]});
  if(term){   // STEP 4: 중도 해지 — 사용권자산/리스부채 제거, 차액 = 리스해지손익
    const t=term, L4=[
      {side:"dr",acc:"리스부채",amt:t.liab},
      {side:"dr",acc:"감가상각누계액",amt:t.cumDep},
      {side:"cr",acc:"사용권자산",amt:rou},
    ];
    if(t.penalty>0) L4.push({side:"cr",acc:"현금(해지 위약금)",amt:t.penalty});
    if(t.gainLoss>0) L4.push({side:"cr",acc:"리스해지이익",amt:t.gainLoss});
    else if(t.gainLoss<0) L4.push({side:"dr",acc:"리스해지손실",amt:-t.gainLoss});
    E.push({step:4,date:t.date,memo:"중도 해지 (사용권자산/리스부채 제거)",lines:L4});
    if(inp.deposit>0){
      const dl=[{side:"dr",acc:"현금(임차보증금 반환)",amt:inp.deposit},{side:"cr",acc:"임차보증금",amt:t.depositBook}];
      if(t.depositDiff>0) dl.push({side:"cr",acc:"이자수익",amt:t.depositDiff});
      E.push({step:4,date:t.date,memo:"중도 해지 (임차보증금 반환)",lines:dl});
    }
  }
  return E;
}

function view(m){
  const {inp,i,n,liability0,rou,rows,complete,partial,depositPV,depositDisc,cur0,endDate,settleDate,term,stub}=m;
  const sd=settleDate;
  const freqTxt={1:"매월",3:"분기",6:"반기",12:"매년"}[inp.periodMonths];
  const timeTxt=inp.timing==="due"?"기초(선급)":"기말(후급)";
  let html="";

  /* 자투리(부분회차) 안내: 리스기간이 지급주기의 배수가 아닐 때 */
  if(stub){
    html+=`<div class="note" style="border-color:#f0b100;background:#fffbeb;color:#92400e;">리스기간이 지급주기의 배수가 아니어서 <b>마지막 회차가 ${stub.months}개월짜리 부분회차</b>로 처리되었습니다(이자·감가상각·할인 모두 해당 기간만큼만 반영). 마지막 회차 리스료는 ${stub.autoProrated?`정기리스료를 기간비례로 <b>자동 안분한 추정치 ${won(stub.pay)}</b>입니다. 계약상 실제 금액이 다르면 <b>[마지막 회차 리스료]</b>에 직접 입력하세요.`:`입력하신 <b>${won(stub.pay)}</b>을 사용했습니다.`}</div>`;
  }

  /* 0. 요약 KPI */
  const totDep = rows.slice(0,complete).reduce((s,r)=>s+r.dep,0) + (partial?partial.dep:0);
  const totInt = rows.slice(0,complete).reduce((s,r)=>s+r.interest,0) + (partial?partial.interest:0);
  const totDepInt = rows.slice(0,complete).reduce((s,r)=>s+r.depInt,0) + (partial?partial.depInt:0);
  const liabBal = complete? rows[complete-1].end : liability0;
  const liabAtReport = liabBal + (partial?partial.interest:0);
  const curAtReport = complete? rows[complete-1].cur : cur0;
  const noncurAtReport = liabAtReport - Math.min(curAtReport,liabAtReport);
  const bookROU = rou - totDep;
  html+=`<div class="sec"><div class="kpis">
    <div class="kpi"><div class="k">사용권자산 취득금액</div><div class="v b">${won(rou)}</div></div>
    <div class="kpi"><div class="k">리스부채 최초인식</div><div class="v b">${won(liability0)}</div></div>
    <div class="kpi"><div class="k">적용이자율(연)</div><div class="v">${(inp.annualRate*100).toFixed(4)}%</div></div>
    ${term?`<div class="kpi"><div class="k">리스해지${term.gainLoss>=0?"이익":"손실"}</div><div class="v ${term.gainLoss>=0?"g":"r"}">${won(Math.abs(term.gainLoss))}</div></div>`:""}
  </div></div>`;

  /* 보고기간말 재무제표 표시 / 중도 해지 요약 */
  if(term){
    html+=`<div class="sec"><h3><span class="tag">요약</span>중도 해지 결과 (${fmtDate(sd)})</h3>
    <div class="scroll"><table><thead><tr><th>구분</th><th>금액</th><th>비고</th></tr></thead><tbody>
      <tr><td>당기 이자비용</td><td>${won(totInt)}</td><td>해지일까지 / 포괄손익(금융원가)</td></tr>
      <tr><td>당기 감가상각비</td><td>${won(totDep)}</td><td>해지일까지 / 포괄손익(영업비용)</td></tr>
      ${inp.deposit>0?`<tr><td>당기 이자수익(보증금)</td><td>${won(totDepInt)}</td><td>해지일까지 / 포괄손익(금융수익)</td></tr>`:""}
      <tr><td>해지일 리스부채 잔액</td><td>${won(term.liab)}</td><td>제거 대상</td></tr>
      <tr><td>해지일 사용권자산 장부금액</td><td>${won(term.rouBook)}</td><td>취득 ${won(rou)} − 감누 ${won(term.cumDep)}</td></tr>
      ${term.penalty>0?`<tr><td>해지 위약금</td><td>${won(term.penalty)}</td><td>현금 유출</td></tr>`:""}
      <tr class="rep"><td><b>리스해지${term.gainLoss>=0?"이익":"손실"}</b></td><td><b>${won(Math.abs(term.gainLoss))}</b></td><td>포괄손익(${term.gainLoss>=0?"기타수익":"기타비용"})</td></tr>
      <tr><td>해지 후 사용권자산/리스부채</td><td>0</td><td>전액 제거</td></tr>
    </tbody></table></div></div>`;
  } else {
    html+=`<div class="sec"><h3><span class="tag">요약</span>보고기간말 재무제표 표시 (${fmtDate(inp.report)})</h3>
    <div class="scroll"><table><thead><tr><th>구분</th><th>금액</th><th>비고</th></tr></thead><tbody>
      <tr><td>사용권자산(취득원가)</td><td>${won(rou)}</td><td>-</td></tr>
      <tr><td>(−) 감가상각누계액</td><td>${won(totDep)}</td><td>-</td></tr>
      <tr><td><b>사용권자산 장부금액</b></td><td><b>${won(bookROU)}</b></td><td>재무상태표(비유동자산)</td></tr>
      <tr><td><b>리스부채(유동)</b></td><td><b>${won(Math.min(curAtReport,liabAtReport))}</b></td><td>향후 12개월 지급분 PV</td></tr>
      <tr><td><b>리스부채(비유동)</b></td><td><b>${won(noncurAtReport)}</b></td><td>잔액 − 유동</td></tr>
      ${inp.deposit>0?`<tr><td>임차보증금 장부금액</td><td>${won(depositPV+totDepInt)}</td><td>현재가치 + 이자수익 누계</td></tr>`:""}
      <tr><td>당기 이자비용</td><td>${won(totInt)}</td><td>포괄손익계산서(금융원가)</td></tr>
      <tr><td>당기 감가상각비</td><td>${won(totDep)}</td><td>포괄손익계산서(영업비용)</td></tr>
      ${inp.deposit>0?`<tr><td>당기 이자수익(보증금)</td><td>${won(totDepInt)}</td><td>포괄손익계산서(금융수익)</td></tr>`:""}
    </tbody></table></div></div>`;
  }

  /* 1. 개시일 회계처리 */
  const je=buildJournal(m);
  html+=`<div class="sec"><h3><span class="tag">STEP 1</span>리스개시일 회계처리</h3>`;
  je.filter(e=>e.step===1).forEach((e,idx)=>{
    html+=jeBlock(fmtDate(e.date), e.memo, e.lines);
    if(idx===0 && inp.deposit>0) html+=`<div class="note">임차보증금 ${won(inp.deposit)} → 현재가치 ${won(depositPV)} (할인차금 ${won(depositDisc)}은 사용권자산에 가산, 리스기간에 걸쳐 이자수익 인식)</div>`;
  });
  html+=`</div>`;

  /* 2. 리스부채 상각표 (예시 엑셀 형식) */
  let tb="";
  rows.forEach((r,idx)=>{
    const isRep=(idx+1)===complete;
    tb+=`<tr class="${isRep?'rep':''}"><td>${r.p}회</td><td>${fmtDate(r.intDate)}</td>
      <td>${won(r.pay)}</td><td>${won(r.interest)}</td><td>${won(r.principal)}</td>
      <td>${won(r.end)}</td><td>${won(r.cur)}</td><td>${won(r.noncur)}</td>
      <td>${won(r.dep)}</td>${inp.deposit>0?`<td>${won(r.depInt)}</td>`:""}</tr>`;
  });
  html+=`<div class="sec"><h3><span class="tag">STEP 2</span>원금상환 스케줄 및 상각표</h3>
    <div class="scroll"><table><thead><tr>
      <th>회차</th><th>일자</th><th>실제 리스료</th><th>유효이자</th><th>원금상환</th>
      <th>리스부채<br>장부금액</th><th>리스부채<br>(유동)</th><th>리스부채<br>(비유동)</th><th>감가상각비</th>${inp.deposit>0?"<th>보증금<br>이자수익</th>":""}
    </tr></thead><tbody>
      <tr><td>0회</td><td>${fmtDate(inp.start)}</td><td>-</td><td>-</td><td>-</td>
      <td>${won(liability0)}</td><td>${won(cur0)}</td><td>${won(liability0-cur0)}</td><td>-</td>${inp.deposit>0?"<td>-</td>":""}</tr>
      ${tb}</tbody></table></div>
    <div class="hint">하이라이트 행 = ${term?"해지일":"보고기간말"}(${fmtDate(sd)}) 시점 완료 회차 / 유동 = 향후 12개월 지급 리스료의 현재가치</div></div>`;

  /* 3. 결산/해지일 기준 회계처리 (당기 발생분 합산) */
  const D=fmtDate(sd);
  const s3=je.filter(e=>e.step===3);
  html+=`<div class="sec"><h3><span class="tag">STEP 3</span>${term?"해지일까지":"결산일"} 회계처리 <span class="badge">${term?"해지일까지 발생분":"당기 발생분 합산"} / ${D}</span></h3>`;
  s3.forEach(e=> html+=jeBlock(D, e.memo, e.lines));
  if(s3.length===0) html+=`<div class="note">${term?"해지일":"결산일"}까지 인식할 회계처리가 없습니다.</div>`;
  html+=`<div class="note">개시일(${fmtDate(inp.start)})부터 ${term?"해지일":"결산일"}(${D})까지 발생한 이자/감가상각/리스료 지급을 합산 표시했습니다. 상각표대로 <b>월할(완전 경과 개월수)</b>로 반영되며, 지급기간 중간이면 일 미달분은 반영하지 않습니다.${partial?` (진행중 기간 중 ${Math.round(partial.frac*inp.periodMonths)}개월분 반영)`:""} 회차별 상세는 STEP 2 상각표를 참고하세요.</div></div>`;

  /* 4. 중도 해지 회계처리 */
  const s4=je.filter(e=>e.step===4);
  if(term && s4.length){
    html+=`<div class="sec"><h3><span class="tag">STEP 4</span>중도 해지 회계처리 <span class="badge">${fmtDate(term.date)}</span></h3>`;
    s4.forEach(e=> html+=jeBlock(fmtDate(term.date), e.memo, e.lines));
    html+=`<div class="note">해지일 시점 리스부채 ${won(term.liab)}, 사용권자산 장부금액 ${won(term.rouBook)}${term.penalty>0?`, 위약금 ${won(term.penalty)}`:""}을 제거하여 <b>리스해지${term.gainLoss>=0?"이익":"손실"} ${won(Math.abs(term.gainLoss))}</b>을 인식합니다.${inp.deposit>0?` 임차보증금은 명목액 ${won(inp.deposit)} 반환(장부 ${won(term.depositBook)} 제거, 잔여 할인 ${won(term.depositDiff)}은 이자수익 인식).`:""} 이자/감가상각은 STEP 3에서 해지일까지 인식 후 잔액을 제거합니다.</div></div>`;
  }

  return html;
}

/* ---------- 최소 XLSX 생성기 (외부 라이브러리 없이 .xlsx 직접 작성) ---------- */
const _crcT=(()=>{const t=[];for(let n=0;n<256;n++){let c=n;for(let k=0;k<8;k++)c=c&1?0xEDB88320^(c>>>1):c>>>1;t[n]=c>>>0;}return t;})();
function _crc32(b){let c=0xFFFFFFFF;for(let i=0;i<b.length;i++)c=_crcT[(c^b[i])&0xFF]^(c>>>8);return(c^0xFFFFFFFF)>>>0;}
function _zip(files){ // files:[{name,data:Uint8Array}] / store(무압축)
  const u16=n=>[n&255,(n>>8)&255], u32=n=>[n&255,(n>>8)&255,(n>>16)&255,(n>>24)&255];
  const parts=[], cen=[]; let off=0;
  for(const f of files){
    const nm=new TextEncoder().encode(f.name), crc=_crc32(f.data), sz=f.data.length;
    const lh=[].concat(u32(0x04034b50),u16(20),u16(0x800),u16(0),u16(0),u16(0),u32(crc),u32(sz),u32(sz),u16(nm.length),u16(0));
    parts.push(new Uint8Array(lh),nm,f.data);
    cen.push(new Uint8Array([].concat(u32(0x02014b50),u16(20),u16(20),u16(0x800),u16(0),u16(0),u16(0),u32(crc),u32(sz),u32(sz),u16(nm.length),u16(0),u16(0),u16(0),u16(0),u32(0),u32(off))),nm);
    off+=lh.length+nm.length+sz;
  }
  const cs=cen.reduce((s,c)=>s+c.length,0);
  const eocd=new Uint8Array([].concat(u32(0x06054b50),u16(0),u16(0),u16(files.length),u16(files.length),u32(cs),u32(off),u16(0)));
  return new Blob([...parts,...cen,eocd],{type:"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
}
const _xE=s=>String(s).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;");
const _col=n=>{let s="";n++;while(n){s=String.fromCharCode(65+(n-1)%26)+s;n=Math.floor((n-1)/26);}return s;};
function _serial(dt){return Math.round((Date.UTC(dt.getFullYear(),dt.getMonth(),dt.getDate())-Date.UTC(1899,11,30))/86400000);}

// 셀 헬퍼: s=스타일idx (0일반,1헤더,2숫자,3날짜,4제목,5테두리텍스트,6퍼센트)
const T=(v,s=5)=>({t:1,v,s}), N=(v,s=2)=>({t:0,v:Math.round(v),s}), Dt=(v,s=3)=>({t:0,v:_serial(v),s}), Pc=(v,s=6)=>({t:0,v,s}), E=()=>({t:1,v:"",s:5});
const Nd=(v,s=12)=>({t:0,v,s});   // 소수 (반올림 안 함) — 연 할인율 등
const B=(s)=>({t:2,s});           // 빈 셀 (값 없이 서식만 유지 — 입력 시 콤마/날짜서식 적용)
const Y=()=>({t:2,s:14});         // 빈 셀 (연한 노란색 = 수동 입력 필요 / 금액서식)
const F=(f,v,s=2)=>({t:3,f,v:Math.round(v),s});   // 수식 셀 (f=엑셀수식[= 제외], v=캐시값)
function _mkSheet(R2, widths, merges, views, tail, rowHt){
  let body="", maxc=0;
  R2.forEach((cells,ri)=>{
    maxc=Math.max(maxc,cells.length); let rc="";
    cells.forEach((c,ci)=>{ if(!c)return; const ref=_col(ci)+(ri+1);
      rc += c.t===2 ? `<c r="${ref}" s="${c.s}"/>`
          : c.t===3 ? `<c r="${ref}" s="${c.s}"><f>${_xE(c.f)}</f><v>${c.v}</v></c>`
          : c.t===0 ? `<c r="${ref}" s="${c.s}"><v>${c.v}</v></c>`
                    : `<c r="${ref}" s="${c.s}" t="inlineStr"><is><t xml:space="preserve">${_xE(c.v)}</t></is></c>`;
    });
    const _h=rowHt&&rowHt[ri+1];
    body+=`<row r="${ri+1}"${_h?` ht="${_h}" customHeight="1"`:""}>${rc}</row>`;
  });
  const mc=(merges&&merges.length)?`<mergeCells count="${merges.length}">${merges.map(r=>`<mergeCell ref="${r}"/>`).join("")}</mergeCells>`:"";
  return `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<worksheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main"><dimension ref="A1:${_col(Math.max(0,maxc-1))}${R2.length||1}"/>${views||'<sheetViews><sheetView workbookViewId="0" showGridLines="0"/></sheetViews>'}${widths}<sheetData>${body}</sheetData>${mc}${tail||""}</worksheet>`;
}

/* ── 상각표 시트 XML (개별/종합 공용) / 값이 아닌 엑셀 수식으로 산출(회계사 검증용) ──
   개시행=7행 / 회차 p = 7+p행 / 기간할인율=$I$3 / 보증금=$J$3 / 사용권자산(취득원가)=$L$7
   엔진이 '매기 반올림 후 이월'이므로 ROUND(기초×기간이자율,0) 수식이 셀 단위로 엔진값과 정확히 일치.
   유동 = 향후 12개월 리스료의 현재가치 = NPV($I$3, 다음 per12개 리스료). 마지막 회차는 0으로 완전상각. */
function _amortSheetXML(m){
  const {rows,liability0,cur0,inp,i,rou,endDate,depositPV}=m;
  const dep=inp.deposit>0;
  const n=rows.length;
  const per12=Math.round(12/inp.periodMonths);             // 12개월 내 지급 회차 수
  const due=inp.timing==="due";
  // 자투리(부분회차)가 있으면 NPV/균등상각 수식이 등기간을 전제해 어긋나므로, 그 경우만 값 셀로 내보내 엔진값과 정확히 일치시킨다
  const Fx = m.stub ? (fx,v,s=2)=>N(v,s) : F;
  const RATE="$I$3", DEP="$J$3", ROU="$L$7";
  const last7=7+n;                                          // 마지막 데이터 행
  const R2=[];                                             // A열=여백, 내용은 B열부터
  R2.push([]);                                             // 1행: 여백
  const ihd=[T("자산명",1),T("리스개시일",1),T("리스종료일",1),T("리스기간(월)",1),T("정기리스료",1),T("통화",1),T("연할인율",1),T("기간할인율",1),T("보증금",1)];
  const ival=[T(inp.assetName||"-"),Dt(inp.start),Dt(endDate),N(inp.termMonths),N(inp.payment),T("KRW"),Pc(inp.annualRate),Pc(i),N(inp.deposit)];
  if(m.term){ ihd.push(T("중도해지일",1)); ival.push(Dt(m.term.date)); }   // 중도해지 리스만 표기 (K열 / 수식참조 $I$3, $J$3, $L$7 불변)
  R2.push([null,...ihd]);
  R2.push([null,...ival]);
  R2.push([]);                                             // 4행: 여백
  R2.push([null,T("[ 리스상환스케쥴 및 상각표 ]",4)]);
  const hd=["회차","일자","실제 리스료","유효이자","원금상환","리스부채 장부금액","리스부채(유동)","리스부채(비유동)","감가상각비","감가상각누계액","사용권자산"];
  if(dep) hd.push("보증금 유효이자","현금수령액","임차보증금 장부금액");
  R2.push([null,...hd.map(h=>T(h,1))]);
  // 개시행(회차0, 7행): 리스부채 = 리스료 현재가치(NPV) / 유동 = 향후 12개월분 PV (개시부채 상한)
  const fLiab0 = due ? (n>=2?`ROUND(D8+NPV(${RATE},D9:D${last7}),0)`:`D8`)
                     : `ROUND(NPV(${RATE},D8:D${last7}),0)`;
  const c0End = 7+Math.min(due?per12+1:per12, n);
  const fCur0 = due ? (c0End>=9?`MIN(ROUND(D8+NPV(${RATE},D9:D${c0End}),0),G7)`:`MIN(D8,G7)`)
                    : `MIN(ROUND(NPV(${RATE},D8:D${c0End}),0),G7)`;
  const z=[N(0),Dt(inp.start),E(),E(),E(),Fx(fLiab0,liability0),Fx(fCur0,cur0),Fx("G7-H7",liability0-cur0),E(),N(0),N(rou)];
  if(dep) z.push(E(),E(),N(depositPV));
  R2.push([null,...z]);
  // 회차별 상각 (전부 수식)
  let acc=0;
  rows.forEach((r,idx)=>{
    acc+=r.dep;
    const p=idx+1, R=7+p, P=R-1, isLast=(p===n);
    const zb=idx%2===1, sN=zb?7:2, sD=zb?8:3, f=(fx,v)=>Fx(fx,v,sN);
    // 유효이자: 후급=ROUND(기초×이자율) / 선급=ROUND((기초−리스료)×이자율) / 후급 마지막은 단수차 조정(리스료−기초)
    const fInt = (!isLast||due) ? (due?`ROUND((G${P}-D${R})*${RATE},0)`:`ROUND(G${P}*${RATE},0)`)
                                : `D${R}-G${P}`;
    // 기말 리스부채 = 기초−리스료+유효이자 / 마지막은 0으로 완전상각(후급은 수식, 선급은 강제 0)
    const cG = isLast ? (due?N(0,sN):f(`G${P}-F${R}`,0)) : f(`G${P}-D${R}+E${R}`,r.end);
    // 유동: 잔여≤12개월이면 전액 유동(기말) / 아니면 향후 per12개 리스료 NPV / 마지막은 0
    const cH = isLast ? N(0,sN)
             : (n-p<=per12 ? f(`G${R}`,r.cur) : f(`ROUND(NPV(${RATE},D${R+1}:D${R+per12}),0)`,r.cur));
    // 감가상각비 정액 / 마지막은 잔여상각액(취득원가−기왕누계)
    const fDep = isLast ? (n>=2?`${ROU}-SUM(J8:J${P})`:`${ROU}`) : `ROUND(${ROU}/${n},0)`;
    const row=[N(r.p,sN),Dt(r.intDate,sD),N(r.pay,sN),
      f(fInt,r.interest), f(`D${R}-E${R}`,r.principal), cG, cH,
      f(`G${R}-H${R}`,r.noncur), f(fDep,r.dep), f(`K${P}+J${R}`,acc), f(ROU,rou)];
    if(dep) row.push(
      f(isLast?`${DEP}-O${P}`:`ROUND(O${P}*${RATE},0)`, r.depInt),
      N(r.depCash,sN),
      f(`O${P}+M${R}`, r.depBal));
    R2.push([null,...row]);
  });
  const last=hd.length+1;                                  // 데이터 마지막 열 (여백열 A 포함)
  return _mkSheet(R2,
    `<cols><col min="1" max="1" width="2.14"/><col min="2" max="2" width="6"/><col min="3" max="3" width="13"/><col min="4" max="${last}" width="16"/></cols>`,
    null,
    `<sheetViews><sheetView workbookViewId="0" showGridLines="0"><pane ySplit="6" topLeftCell="A7" activePane="bottomLeft" state="frozen"/><selection pane="bottomLeft" activeCell="A7" sqref="A7"/></sheetView></sheetViews>`);
}

/* ── 회계처리 시트 XML (차변/대변 T자형 / 개별/종합 공용) ── */
function _journalSheetXML(entries){
  const J=[];                                                  // A열=여백, 내용은 B열부터 / 병합 없음
  J.push([]);                                                  // 1행: 여백
  J.push([null,T("[ 회계처리 ]",4)]);                           // 2행: 제목
  J.push([]);                                                  // 3행: 여백
  entries.forEach(e=>{
    J.push([null,T(`${fmtDate(e.date)}  -  ${e.memo}`,13),B(13),B(13),B(13)]);  // 전표 캡션 (B에 제목, C~E는 값없는 채움 → 제목이 안 잘리고 넘침 표시)
    J.push([]);                                                // 여백
    J.push([null,T("<차변>",4),null,T("<대변>",4)]);            // 소제목 (채움 없음)
    J.push([null,T("계정명",1),T("금액",1),T("계정명",1),T("금액",1)]);
    const drs=e.lines.filter(l=>l.side==="dr"), crs=e.lines.filter(l=>l.side==="cr");
    for(let k=0;k<Math.max(drs.length,crs.length);k++){
      const d=drs[k], c=crs[k];
      J.push([null, d?T(d.acc):E(), d?N(d.amt):E(), c?T(c.acc):E(), c?N(c.amt):E() ]);
    }
    J.push([]);                                                // 여백
  });
  return _mkSheet(J, `<cols><col min="1" max="1" width="2.14"/><col min="2" max="2" width="26"/><col min="3" max="3" width="18"/><col min="4" max="4" width="26"/><col min="5" max="5" width="18"/></cols>`);
}

/* ── Office 2013~2022 표준 테마 (색: accent1=4472C4 / 글꼴: Calibri Light/Calibri, 한글 맑은 고딕) ── */
const THEME_XML=`<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office 테마"><a:themeElements><a:clrScheme name="Office"><a:dk1><a:sysClr val="windowText" lastClr="000000"/></a:dk1><a:lt1><a:sysClr val="window" lastClr="FFFFFF"/></a:lt1><a:dk2><a:srgbClr val="44546A"/></a:dk2><a:lt2><a:srgbClr val="E7E6E6"/></a:lt2><a:accent1><a:srgbClr val="4472C4"/></a:accent1><a:accent2><a:srgbClr val="ED7D31"/></a:accent2><a:accent3><a:srgbClr val="A5A5A5"/></a:accent3><a:accent4><a:srgbClr val="FFC000"/></a:accent4><a:accent5><a:srgbClr val="5B9BD5"/></a:accent5><a:accent6><a:srgbClr val="70AD47"/></a:accent6><a:hlink><a:srgbClr val="0563C1"/></a:hlink><a:folHlink><a:srgbClr val="954F72"/></a:folHlink></a:clrScheme><a:fontScheme name="Office"><a:majorFont><a:latin typeface="Calibri Light" panose="020F0302020204030204"/><a:ea typeface=""/><a:cs typeface=""/><a:font script="Jpan" typeface="游ゴシック Light"/><a:font script="Hang" typeface="맑은 고딕"/><a:font script="Hans" typeface="等线 Light"/><a:font script="Hant" typeface="新細明體"/></a:majorFont><a:minorFont><a:latin typeface="Calibri" panose="020F0502020204030204"/><a:ea typeface=""/><a:cs typeface=""/><a:font script="Jpan" typeface="游ゴシック"/><a:font script="Hang" typeface="맑은 고딕"/><a:font script="Hans" typeface="等线"/><a:font script="Hant" typeface="新細明體"/></a:minorFont></a:fontScheme><a:fmtScheme name="Office"><a:fillStyleLst><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:gradFill rotWithShape="1"><a:gsLst><a:gs pos="0"><a:schemeClr val="phClr"><a:lumMod val="110000"/><a:satMod val="105000"/><a:tint val="67000"/></a:schemeClr></a:gs><a:gs pos="50000"><a:schemeClr val="phClr"><a:lumMod val="105000"/><a:satMod val="103000"/><a:tint val="73000"/></a:schemeClr></a:gs><a:gs pos="100000"><a:schemeClr val="phClr"><a:lumMod val="105000"/><a:satMod val="109000"/><a:tint val="81000"/></a:schemeClr></a:gs></a:gsLst><a:lin ang="5400000" scaled="0"/></a:gradFill><a:gradFill rotWithShape="1"><a:gsLst><a:gs pos="0"><a:schemeClr val="phClr"><a:satMod val="103000"/><a:lumMod val="102000"/><a:tint val="94000"/></a:schemeClr></a:gs><a:gs pos="50000"><a:schemeClr val="phClr"><a:satMod val="110000"/><a:lumMod val="100000"/><a:shade val="100000"/></a:schemeClr></a:gs><a:gs pos="100000"><a:schemeClr val="phClr"><a:lumMod val="99000"/><a:satMod val="120000"/><a:shade val="78000"/></a:schemeClr></a:gs></a:gsLst><a:lin ang="5400000" scaled="0"/></a:gradFill></a:fillStyleLst><a:lnStyleLst><a:ln w="6350" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/><a:miter lim="800000"/></a:ln><a:ln w="12700" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/><a:miter lim="800000"/></a:ln><a:ln w="19050" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/><a:miter lim="800000"/></a:ln></a:lnStyleLst><a:effectStyleLst><a:effectStyle><a:effectLst/></a:effectStyle><a:effectStyle><a:effectLst/></a:effectStyle><a:effectStyle><a:effectLst><a:outerShdw blurRad="57150" dist="19050" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="63000"/></a:srgbClr></a:outerShdw></a:effectLst></a:effectStyle></a:effectStyleLst><a:bgFillStyleLst><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:solidFill><a:schemeClr val="phClr"><a:tint val="95000"/><a:satMod val="170000"/></a:schemeClr></a:solidFill><a:gradFill rotWithShape="1"><a:gsLst><a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="93000"/><a:satMod val="150000"/><a:shade val="98000"/><a:lumMod val="102000"/></a:schemeClr></a:gs><a:gs pos="50000"><a:schemeClr val="phClr"><a:tint val="98000"/><a:satMod val="130000"/><a:shade val="90000"/><a:lumMod val="103000"/></a:schemeClr></a:gs><a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="63000"/><a:satMod val="120000"/></a:schemeClr></a:gs></a:gsLst><a:lin ang="5400000" scaled="0"/></a:gradFill></a:bgFillStyleLst></a:fmtScheme></a:themeElements><a:objectDefaults/><a:extraClrSchemeLst/></a:theme>`;

/* ── 워크북 저장 (sheets:[{name,xml}] → .xlsx 다운로드) ── */
function _saveWB(fname, sheets){
  const styles=`<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<styleSheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main"><numFmts count="3"><numFmt numFmtId="166" formatCode="0.####"/><numFmt numFmtId="164" formatCode="yyyy\\-mm\\-dd"/><numFmt numFmtId="165" formatCode="#,##0_);[Red](#,##0);-_)"/></numFmts><fonts count="3"><font><sz val="10"/><name val="맑은 고딕"/></font><font><b/><sz val="10"/><name val="맑은 고딕"/></font><font><b/><sz val="10"/><color rgb="FFFFFFFF"/><name val="맑은 고딕"/></font></fonts><fills count="7"><fill><patternFill patternType="none"/></fill><fill><patternFill patternType="gray125"/></fill><fill><patternFill patternType="solid"><fgColor rgb="FFACB9CA"/></patternFill></fill><fill><patternFill patternType="solid"><fgColor rgb="FFF7F9FB"/></patternFill></fill><fill><patternFill patternType="solid"><fgColor rgb="FFEEF1F4"/></patternFill></fill><fill><patternFill patternType="solid"><fgColor rgb="FF222B35"/></patternFill></fill><fill><patternFill patternType="solid"><fgColor rgb="FFFFF2CC"/></patternFill></fill></fills><borders count="2"><border><left/><right/><top/><bottom/><diagonal/></border><border><left style="thin"><color rgb="FFBFBFBF"/></left><right style="thin"><color rgb="FFBFBFBF"/></right><top style="thin"><color rgb="FFBFBFBF"/></top><bottom style="thin"><color rgb="FFBFBFBF"/></bottom><diagonal/></border></borders><cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs><cellXfs count="15"><xf numFmtId="0" fontId="0" fillId="0" borderId="0" xfId="0"/><xf numFmtId="0" fontId="1" fillId="2" borderId="1" xfId="0" applyFont="1" applyFill="1" applyBorder="1" applyAlignment="1"><alignment horizontal="center"/></xf><xf numFmtId="165" fontId="0" fillId="0" borderId="1" xfId="0" applyNumberFormat="1" applyBorder="1"/><xf numFmtId="164" fontId="0" fillId="0" borderId="1" xfId="0" applyNumberFormat="1" applyBorder="1" applyAlignment="1"><alignment horizontal="center"/></xf><xf numFmtId="0" fontId="1" fillId="0" borderId="0" xfId="0" applyFont="1"/><xf numFmtId="0" fontId="0" fillId="0" borderId="1" xfId="0" applyBorder="1"/><xf numFmtId="10" fontId="0" fillId="0" borderId="1" xfId="0" applyNumberFormat="1" applyBorder="1"/><xf numFmtId="165" fontId="0" fillId="3" borderId="1" xfId="0" applyNumberFormat="1" applyFill="1" applyBorder="1"/><xf numFmtId="164" fontId="0" fillId="3" borderId="1" xfId="0" applyNumberFormat="1" applyFill="1" applyBorder="1" applyAlignment="1"><alignment horizontal="center"/></xf><xf numFmtId="0" fontId="0" fillId="3" borderId="1" xfId="0" applyFill="1" applyBorder="1"/><xf numFmtId="0" fontId="1" fillId="4" borderId="1" xfId="0" applyFont="1" applyFill="1" applyBorder="1" applyAlignment="1"><alignment horizontal="left"/></xf><xf numFmtId="165" fontId="1" fillId="4" borderId="1" xfId="0" applyNumberFormat="1" applyFont="1" applyFill="1" applyBorder="1"/><xf numFmtId="166" fontId="0" fillId="0" borderId="1" xfId="0" applyNumberFormat="1" applyBorder="1"/><xf numFmtId="0" fontId="2" fillId="5" borderId="0" xfId="0" applyFont="1" applyFill="1" applyAlignment="1"><alignment horizontal="left"/></xf><xf numFmtId="165" fontId="0" fillId="6" borderId="1" xfId="0" applyNumberFormat="1" applyFill="1" applyBorder="1"/></cellXfs><cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles></styleSheet>`;
  const ct=`<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<Types xmlns="http://schemas.openxmlformats.org/package/2006/content-types"><Default Extension="rels" ContentType="application/vnd.openxmlformats-package.relationships+xml"/><Default Extension="xml" ContentType="application/xml"/><Override PartName="/xl/workbook.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml"/>${sheets.map((s,ix)=>`<Override PartName="/xl/worksheets/sheet${ix+1}.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml"/>`).join("")}<Override PartName="/xl/styles.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml"/><Override PartName="/xl/theme/theme1.xml" ContentType="application/vnd.openxmlformats-officedocument.theme+xml"/></Types>`;
  const rels=`<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships"><Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument" Target="xl/workbook.xml"/></Relationships>`;
  const wb=`<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<workbook xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships"><sheets>${sheets.map((s,ix)=>`<sheet name="${_xE(s.name)}" sheetId="${ix+1}" r:id="rId${ix+1}"/>`).join("")}</sheets><calcPr fullCalcOnLoad="1"/></workbook>`;
  const wbr=`<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">${sheets.map((s,ix)=>`<Relationship Id="rId${ix+1}" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet" Target="worksheets/sheet${ix+1}.xml"/>`).join("")}<Relationship Id="rId${sheets.length+1}" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles" Target="styles.xml"/><Relationship Id="rId${sheets.length+2}" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme" Target="theme/theme1.xml"/></Relationships>`;
  const enc=s=>new TextEncoder().encode(s);
  const files=[
    {name:"[Content_Types].xml",data:enc(ct)},
    {name:"_rels/.rels",data:enc(rels)},
    {name:"xl/workbook.xml",data:enc(wb)},
    {name:"xl/_rels/workbook.xml.rels",data:enc(wbr)},
    {name:"xl/styles.xml",data:enc(styles)},
    {name:"xl/theme/theme1.xml",data:enc(THEME_XML)},
  ];
  sheets.forEach((s,ix)=>files.push({name:`xl/worksheets/sheet${ix+1}.xml`,data:enc(s.xml)}));
  const a=document.createElement("a");
  a.href=URL.createObjectURL(_zip(files)); a.download=fname; a.click();
}

function exportXLSX(){
  if(!LAST){ alert("먼저 회계처리를 생성하세요."); return; }
  _saveWB(`${(LAST.inp.assetName||"리스").replace(/[\\/:*?"<>|]/g,"")}_상각표.xlsx`,[
    {name:"상각표",xml:_amortSheetXML(LAST)},
    {name:"회계처리",xml:_journalSheetXML(buildJournal(LAST))},
  ]);
}

/* ---------- 리스 목록 (저장/불러오기) & 종합 결산 ---------- */
let LASTT=null;
const LS_KEY="lease1116.leases";
const ASSET_TYPES=["토지","건물및구축물","차량운반구","시설장치","기계장치","기타"];   // 기초자산유형 (K-IFRS 1116 주석 공시 구분 / 공백 없는 표기)
const normType=s=>{ const n=String(s||"").replace(/\s/g,""); return ASSET_TYPES.find(t=>t.replace(/\s/g,"")===n)||"기타"; };  // 미지정/비표준은 기타
const LFIELDS=["assetName","assetType","startDate","termMonths","reportDate","payment","firstPay","lastPay","freq","timing","payDay","firstPayDate","rate","rateConv","deposit","idc","incentive","prepaid","restore","terminateDate","termPenalty"];
function lsLoad(){ try{ return JSON.parse(localStorage.getItem(LS_KEY))||[]; }catch(e){ return []; } }
function lsSave(L){ localStorage.setItem(LS_KEY,JSON.stringify(L)); }

function showTab(t){
  ["S","T"].forEach(x=>{
    document.getElementById("view"+x).style.display = t===x?"":"none";
    document.getElementById("tab"+x).classList.toggle("on",t===x);
  });
}

/* 시작 안내 스트립 접기 (다시 보지 않기) */
const GUIDE_KEY="lease1116.guideHidden";
function hideGuide(){ localStorage.setItem(GUIDE_KEY,"1"); const g=document.getElementById("guide"); if(g) g.style.display="none"; }
function showGuide(){ localStorage.removeItem(GUIDE_KEY); const g=document.getElementById("guide"); if(g) g.style.display=""; g&&g.scrollIntoView({behavior:"smooth",block:"nearest"}); }

function saveLease(){
  const f={}; LFIELDS.forEach(id=>f[id]=document.getElementById(id).value);
  const inp=buildInp(id=>f[id]);
  if(isNaN(inp.start.getTime())||!(inp.termMonths>=1)||!(inp.payment>0)||f.rate===""){
    alert("리스개시일 / 리스기간 / 정기리스료 / 연 할인율을 입력한 뒤 저장하세요."); return;
  }
  const L=lsLoad();
  let name=inp.assetName;
  if(!name){ let k=1; while(L.some(x=>x.name==="리스"+k)) k++; name="리스"+k;
    document.getElementById("assetName").value=name; f.assetName=name; }
  const ix=L.findIndex(x=>x.name===name);
  if(ix>=0) L[ix].f=f; else L.push({name,f});
  lsSave(L); renderLeaseList();
  alert(`'${name}' ${ix>=0?"업데이트":"저장"} 완료 — ② 리스 목록 / 종합 결산 탭에서 확인하세요.`);
}

function renderLeaseList(){
  const L=lsLoad(), el=document.getElementById("leaseList");
  if(!L.length){ el.innerHTML='<div class="empty" style="padding:26px 10px;">저장된 리스가 없습니다.</div>'; return; }
  el.innerHTML=`<div class="scroll lslist" style="max-height:280px;"><table><thead><tr>
    <th>자산명</th><th>개시일</th><th>기간</th><th>정기리스료</th><th>관리</th></tr></thead><tbody>`+
    L.map((x,ix)=>`<tr><td>${_xE(x.name)}</td><td>${_xE(x.f.startDate||"-")}</td><td>${_xE(x.f.termMonths||"-")}개월</td><td>${_xE(x.f.payment||"-")}</td>
      <td><div style="display:flex; gap:5px; justify-content:flex-end;"><button class="llbtn" data-click="loadLease:${ix}">열기</button><button class="llbtn del" data-click="delLease:${ix}">삭제</button></div></td></tr>`).join("")+
    `</tbody></table></div>`;
}
function loadLease(ix){
  const lz=lsLoad()[ix]; if(!lz) return;
  LFIELDS.forEach(id=>{ document.getElementById(id).value = lz.f[id]==null?"":lz.f[id]; });
  showTab("S"); run();
}
function delLease(ix){
  const L=lsLoad(); if(!L[ix]) return;
  if(!confirm(`'${L[ix].name}' 리스를 목록에서 삭제할까요?`)) return;
  L.splice(ix,1); lsSave(L); renderLeaseList();
}
function clearAllLeases(){
  const L=lsLoad();
  if(!L.length){ alert("저장된 리스가 없습니다."); return; }
  if(!confirm(`저장된 리스 ${L.length}건을 모두 삭제합니다. 되돌릴 수 없습니다. 계속할까요?`)) return;
  lsSave([]); renderLeaseList();
  document.getElementById("outT").innerHTML='<div class="empty">리스를 저장한 뒤 결산기간을 지정하고 <b>종합 결산 생성</b>을 누르세요.</div>';
}
/* 목록 엑셀 열 정의 (저장 f[key] ↔ 엑셀 열) / 내보내기/가져오기 공용
   v = 엑셀 입력 유효성검사 (date=날짜만 / whole=정수 / decimal=숫자만 / list=드롭다운) / 보고기간종료일은 리스공통이라 상단 단일셀 */
const LEASE_COLS=[
  {key:"assetName",  label:"자산명",           kind:"text"},
  {key:"assetType",  label:"기초자산유형",      kind:"text",  v:{t:"list",list:"토지,건물및구축물,차량운반구,시설장치,기계장치,기타"}},
  {key:"startDate",  label:"리스 개시일",       kind:"date",  v:{t:"date",op:"greaterThanOrEqual",f1:"1"}},
  {key:"termMonths", label:"리스기간(개월)",    kind:"int",   v:{t:"whole",op:"greaterThanOrEqual",f1:"1"}},
  {key:"payment",    label:"정기리스료",         kind:"money", v:{t:"decimal",op:"greaterThanOrEqual",f1:"0"}},
  {key:"firstPay",   label:"첫 회차 리스료",     kind:"money", v:{t:"decimal",op:"greaterThanOrEqual",f1:"0"}},
  {key:"lastPay",    label:"마지막 회차 리스료", kind:"money", v:{t:"decimal",op:"greaterThanOrEqual",f1:"0"}},
  {key:"freq",       label:"지급주기",           kind:"enum",  map:{1:"매월",3:"분기",6:"반기",12:"매년"}, v:{t:"list",list:"매월,분기,반기,매년"}},
  {key:"timing",     label:"지급시점",           kind:"enum",  map:{ordinary:"기말(후급)",due:"기초(선급)"}, v:{t:"list",list:"기말(후급),기초(선급)"}},
  {key:"payDay",     label:"지급일",             kind:"int",   v:{t:"whole",op:"between",f1:"1",f2:"31"}},
  {key:"firstPayDate",label:"첫 납입일",          kind:"date",  v:{t:"date",op:"greaterThanOrEqual",f1:"1"}},
  {key:"rate",       label:"연 할인율(%)",       kind:"dec",   v:{t:"decimal",op:"between",f1:"0.1",f2:"100"}},
  {key:"rateConv",   label:"할인율 방식",        kind:"enum",  map:{nominal:"명목",effective:"실효"}, v:{t:"list",list:"명목,실효"}},
  {key:"deposit",    label:"임차보증금",         kind:"money", v:{t:"decimal",op:"greaterThanOrEqual",f1:"0"}},
  {key:"idc",        label:"리스개설직접원가",   kind:"money", v:{t:"decimal",op:"greaterThanOrEqual",f1:"0"}},
  {key:"incentive",  label:"리스인센티브",       kind:"money", v:{t:"decimal",op:"greaterThanOrEqual",f1:"0"}},
  {key:"prepaid",    label:"선급리스료",         kind:"money", v:{t:"decimal",op:"greaterThanOrEqual",f1:"0"}},
  {key:"restore",    label:"복구원가",           kind:"money", v:{t:"decimal",op:"greaterThanOrEqual",f1:"0"}},
  {key:"terminateDate",label:"중도 해지일",        kind:"date",  v:{t:"date",op:"greaterThanOrEqual",f1:"1"}},
  {key:"termPenalty",label:"해지 위약금",          kind:"money", v:{t:"decimal",op:"greaterThanOrEqual",f1:"0"}},
];
const REPORT_LABEL="보고기간 종료일";
const RATING_LABEL="신용등급";
const YTMDATE_LABEL="할인율 기준일자(선택)";

function _leaseBlank(c){   // 빈 셀도 열 서식 유지 (날짜=3, 금액/정수=2, 소수=12, 그 외=일반테두리)
  return c.kind==="date" ? B(3) : (c.kind==="money"||c.kind==="int") ? B(2) : c.kind==="dec" ? B(12) : E();
}
function _leaseCell(c, fval){
  if(fval==null || String(fval).trim()==="") return _leaseBlank(c);
  const s=String(fval).trim();
  switch(c.kind){
    case "text":  return T(s);
    case "date":  { const d=parseDate(s); return isNaN(d.getTime())?T(s):Dt(d); }
    case "int":   { const n=parseInt(s.replace(/[^\d-]/g,""),10); return isNaN(n)?_leaseBlank(c):N(n); }
    case "money": { const n=Math.round(+s.replace(/,/g,"")); return isNaN(n)?_leaseBlank(c):N(n,2); }
    case "dec":   { const n=+s.replace(/,/g,""); return isNaN(n)?_leaseBlank(c):Nd(n); }
    case "enum":  return T(c.map[s]||s);
  }
  return T(s);
}
function _dv(v, sqref){    // dataValidation 1개 XML
  const msg={date:"날짜만 입력하세요 (YYYY-MM-DD).", whole:"정수만 입력하세요.",
    decimal:"숫자만 입력하세요 (% 기호 없이 / 예: 8.06).", list:"목록에서 선택하세요."}[v.t];
  const base=`allowBlank="1" showErrorMessage="1" errorTitle="입력 오류" error="${_xE(msg)}" sqref="${sqref}"`;
  if(v.t==="list") return `<dataValidation type="list" ${base}><formula1>"${v.list}"</formula1></dataValidation>`;
  return `<dataValidation type="${v.t}" operator="${v.op}" ${base}><formula1>${v.f1}</formula1>${v.f2!=null?`<formula2>${v.f2}</formula2>`:""}</dataValidation>`;
}
function _leasesWorkbook(L, blankRows, fname){    // 리스목록 시트 생성 (목록 저장분 / 빈 양식 공용)
  const ncol=LEASE_COLS.length;
  const HR=9, FIRST=HR+1, LAST=500;                        // A열=여백 / 상단 대표셀(보고일/신용등급/기준일자)+안내 2행 / 머리글 9행 / 데이터 10행부터
  const rep=(L.find(x=>x.f.reportDate&&x.f.reportDate.trim())||{f:{}}).f.reportDate||"";
  const repD=rep?parseDate(rep):null;
  const R2=[];
  R2.push([]);                                            // 1행: 여백
  R2.push([null,T("리스 목록",4)]);                        // 2행: 제목
  R2.push([null,T(REPORT_LABEL,1), (repD&&!isNaN(repD.getTime()))?Dt(repD):E()]); // 3행: 보고기간 종료일
  R2.push([null,T(RATING_LABEL,1), E()]);                 // 4행: 신용등급 (대표셀 / 드롭다운)
  R2.push([null,T(YTMDATE_LABEL,1), E()]);                // 5행: 할인율 기준일자(공통/선택)
  R2.push([null,T("‘연 할인율(%)’을 비워두면 [신용등급] + 각 리스 개시일(또는 위 기준일자)로 내장 YTM에서 자동 산출합니다.",0)]); // 6행: 안내1
  R2.push([null,T("입력/수정 후 [엑셀로 목록 가져오기] 업로드",0)]);   // 7행: 안내2
  R2.push([]);                                            // 8행: 여백
  R2.push([null,...LEASE_COLS.map(c=>T(c.label,1))]);     // 9행: 머리글
  L.forEach(x=>{ R2.push([null,...LEASE_COLS.map(c=>_leaseCell(c, x.f[c.key]))]); });  // 9행+
  for(let e=0;e<blankRows;e++) R2.push([null,...LEASE_COLS.map(_leaseBlank)]);   // 신규 입력용 빈 행 (열 서식 유지)
  const widths=`<cols><col min="1" max="1" width="2.14"/><col min="2" max="2" width="18"/><col min="3" max="3" width="14"/><col min="4" max="5" width="14"/><col min="6" max="8" width="15"/><col min="9" max="10" width="13"/><col min="11" max="11" width="8"/><col min="12" max="12" width="14"/><col min="13" max="14" width="13"/><col min="15" max="${ncol+1}" width="14"/></cols>`;
  const views=`<sheetViews><sheetView workbookViewId="0" showGridLines="0"><pane ySplit="${HR}" topLeftCell="A${FIRST}" activePane="bottomLeft" state="frozen"/><selection pane="bottomLeft" activeCell="A${FIRST}" sqref="A${FIRST}"/></sheetView></sheetViews>`;
  const dvs=[
    _dv({t:"date",op:"greaterThanOrEqual",f1:"1"}, "C3"),               // 보고기간종료일
    _dv({t:"list", list:YLD_HIST_GRADES.join(",")}, "C4"),              // 신용등급 드롭다운
    _dv({t:"date",op:"greaterThanOrEqual",f1:"1"}, "C5"),              // 할인율 기준일자
  ];
  LEASE_COLS.forEach((c,ix)=>{ if(c.v){ const col=_col(ix+1); dvs.push(_dv(c.v, `${col}${FIRST}:${col}${LAST}`)); } });   // +1 = 여백열 A
  const dv=`<dataValidations count="${dvs.length}">${dvs.join("")}</dataValidations>`;
  _saveWB(fname, [{name:"리스목록", xml:_mkSheet(R2, widths, null, views, dv, {1:13.5})}]);   // merges=null (병합 없음)
}
function exportLeasesXLSX(){
  const L=lsLoad(); if(!L.length){ alert("저장된 리스가 없습니다. ① 탭에서 리스를 저장하거나, [빈 양식 내려받기]로 처음부터 입력하세요."); return; }
  const rep=(L.find(x=>x.f.reportDate&&x.f.reportDate.trim())||{f:{}}).f.reportDate||"";
  _leasesWorkbook(L, 3, rep ? `리스목록_${rep}.xlsx` : "리스목록.xlsx");
}
function exportLeaseTemplate(){   // 맨땅에서 시작 — 빈 양식 (저장분 없이 머리글/유효성검사만)
  _leasesWorkbook([], 20, "리스목록_양식.xlsx");
}

/* ── 최소 XLSX 리더 (외부 라이브러리 없이 .xlsx 읽기) ── */
const _u16=(b,o)=>b[o]|(b[o+1]<<8);
const _u32=(b,o)=>(b[o]|(b[o+1]<<8)|(b[o+2]<<16)|(b[o+3]<<24))>>>0;
async function _inflateRaw(bytes){
  if(typeof DecompressionStream==="undefined") throw new Error("이 브라우저는 압축 해제를 지원하지 않습니다. 최신 Edge/Chrome을 사용하세요.");
  const ab=await new Response(new Blob([bytes]).stream().pipeThrough(new DecompressionStream("deflate-raw"))).arrayBuffer();
  return new Uint8Array(ab);
}
async function _unzip(buf){                                   // 중앙디렉터리 기준 파싱 (store/deflate 모두)
  const b=new Uint8Array(buf); let eo=-1;
  for(let i=b.length-22;i>=0;i--){ if(_u32(b,i)===0x06054b50){ eo=i; break; } }
  if(eo<0) throw new Error("ZIP(EOCD)을 찾지 못했습니다.");
  const cnt=_u16(b,eo+10); let p=_u32(b,eo+16); const out={};
  for(let k=0;k<cnt && _u32(b,p)===0x02014b50; k++){
    const method=_u16(b,p+10), compSize=_u32(b,p+20);
    const nameLen=_u16(b,p+28), extraLen=_u16(b,p+30), commentLen=_u16(b,p+32), lho=_u32(b,p+42);
    const name=new TextDecoder().decode(b.subarray(p+46,p+46+nameLen));
    const dataStart=lho+30+_u16(b,lho+26)+_u16(b,lho+28);
    const comp=b.subarray(dataStart,dataStart+compSize);
    out[name]= method===0 ? comp : await _inflateRaw(comp);
    p+=46+nameLen+extraLen+commentLen;
  }
  return out;
}
function _serialToYMD(n){
  const d=new Date(Date.UTC(1899,11,30)+Math.round(n)*86400000);
  return `${d.getUTCFullYear()}-${pad(d.getUTCMonth()+1)}-${pad(d.getUTCDate())}`;
}
function _enumImport(key,s){
  const t=s.replace(/\s/g,"");
  if(key==="freq"){ if(/분기|^3$/.test(t))return"3"; if(/반기|^6$/.test(t))return"6"; if(/매년|^12$/.test(t))return"12"; return"1"; }
  if(key==="timing")   return /선급|기초|due/i.test(t)?"due":"ordinary";
  if(key==="rateConv") return /실효|effective/i.test(t)?"effective":"nominal";
  return s;
}
function _convImport(c, raw){
  if(raw==null || String(raw).trim()==="") return "";
  const s=String(raw).trim();
  switch(c.kind){
    case "text":  return s;
    case "date":
      if(/^\d+(\.\d+)?$/.test(s)) return _serialToYMD(+s);
      { const m=s.replace(/[.\/]/g,"-").match(/(\d{4})-(\d{1,2})-(\d{1,2})/); return m?`${m[1]}-${pad(+m[2])}-${pad(+m[3])}`:""; }
    case "int":   { const n=parseInt(s.replace(/[^\d-]/g,""),10); return isNaN(n)?"":String(n); }
    case "money": { const n=Math.round(+s.replace(/[^\d.\-]/g,"")); return isNaN(n)?"":n.toLocaleString("ko-KR"); }
    case "dec":   { const n=+s.replace(/[^\d.\-]/g,""); return isNaN(n)?"":String(n); }
    case "enum":  return _enumImport(c.key, s);
  }
  return s;
}
async function parseLeaseXLSX(buf){
  const files=await _unzip(buf), dec=new TextDecoder();
  const parse=x=>new DOMParser().parseFromString(x,"application/xml");
  const shared=[];
  if(files["xl/sharedStrings.xml"]){
    const sis=parse(dec.decode(files["xl/sharedStrings.xml"])).getElementsByTagName("si");
    for(const si of sis){ let s=""; for(const t of si.getElementsByTagName("t")) s+=t.textContent; shared.push(s); }
  }
  const sheetKey=Object.keys(files).find(n=>n==="xl/worksheets/sheet1.xml") || Object.keys(files).find(n=>/^xl\/worksheets\/.*\.xml$/.test(n));
  if(!sheetKey) throw new Error("워크시트를 찾지 못했습니다.");
  const doc=parse(dec.decode(files[sheetKey])), rows={};
  for(const r of doc.getElementsByTagName("row")){
    const rn=+r.getAttribute("r"), cells={};
    for(const c of r.getElementsByTagName("c")){
      const ref=c.getAttribute("r"); if(!ref) continue;
      const col=ref.replace(/[0-9]+/g,""), t=c.getAttribute("t");
      let val="";
      if(t==="s"){ const v=c.getElementsByTagName("v")[0]; val=v?(shared[+v.textContent]??""):""; }
      else if(t==="inlineStr"||t==="str"){ const ts=c.getElementsByTagName("t"); val=ts.length?ts[0].textContent:((c.getElementsByTagName("v")[0]||{}).textContent||""); }
      else { const v=c.getElementsByTagName("v")[0]; val=v?v.textContent:""; }
      cells[col]=val;
    }
    rows[rn]=cells;
  }
  const norm=s=>String(s).replace(/\s/g,"");
  const colIdx=s=>{ let n=0; for(const ch of s) n=n*26+(ch.charCodeAt(0)-64); return n-1; };
  const rnums=Object.keys(rows).map(Number).sort((a,b)=>a-b);
  // 상단 대표셀 조회 — 라벨 오른쪽 첫 값
  const topCell=(label)=>{
    for(const rn of rnums){
      const hit=Object.entries(rows[rn]).find(([,v])=>norm(v)===norm(label));
      if(hit){
        const lc=colIdx(hit[0]);
        const right=Object.entries(rows[rn]).map(([c,v])=>[colIdx(c),v]).filter(([ci,v])=>ci>lc&&String(v).trim()!=="").sort((a,b)=>a[0]-b[0]);
        return right.length ? String(right[0][1]).trim() : "";
      }
    }
    return "";
  };
  const sharedReport=_convImport({kind:"date"}, topCell(REPORT_LABEL));
  const sharedRating=topCell(RATING_LABEL);                            // 신용등급 (대표셀)
  const sharedYtmDate=_convImport({kind:"date"}, topCell(YTMDATE_LABEL)); // 할인율 기준일자(공통/선택)
  let headerRow=-1; const labelToCol={};
  for(const rn of rnums){
    const hit=Object.entries(rows[rn]).find(([,v])=>norm(v)===norm("자산명"));
    if(hit){ headerRow=rn; Object.entries(rows[rn]).forEach(([col,v])=>{ if(norm(v)) labelToCol[norm(v)]=col; }); break; }
  }
  if(headerRow<0) throw new Error("머리글(자산명 열)을 찾지 못했습니다.");
  const colOf={}; LEASE_COLS.forEach(c=>{ colOf[c.key]=labelToCol[norm(c.label)]; });
  const result=[]; let auto=0; const manual=[];
  for(const rn of rnums){
    if(rn<=headerRow) continue;
    const cells=rows[rn], f={reportDate:sharedReport};
    LEASE_COLS.forEach(c=>{ const col=colOf[c.key]; f[c.key]=_convImport(c, col?cells[col]:undefined); });
    if(!f.assetName || !f.assetName.trim()) continue;         // 자산명 없는 행은 건너뜀
    if(f.assetType && f.assetType.trim()) f.assetType=normType(f.assetType);   // 띄어쓰기 차이 등 표준 유형으로 정규화
    // 할인율 비었고 신용등급 대표셀이 있으면 내장 YTM 자동 산출 (기준일 = 공통일자 || 각 리스 개시일)
    if((f.rate==null||String(f.rate).trim()==="") && sharedRating){
      const r=ytmRate(sharedYtmDate||f.startDate, sharedRating, +f.termMonths);
      if(r!=null){ f.rate=String(r); auto++; }
      else manual.push(f.assetName.trim());
    }
    result.push({name:f.assetName.trim(), f});
  }
  return {leases:result, info:{auto, manual, rating:sharedRating}};
}

async function importLeasesXLSX(input){
  const file=input.files[0]; if(!file) return;
  try{
    let arr, info=null;
    if(/\.json$/i.test(file.name)){                           // 예전 .json 백업 호환
      arr=JSON.parse(await file.text());
      if(!Array.isArray(arr)||!arr.every(x=>x&&x.name&&x.f)) throw new Error("리스 목록 JSON 형식이 아닙니다.");
    }else{
      const p=await parseLeaseXLSX(await file.arrayBuffer()); arr=p.leases; info=p.info;
    }
    if(!arr.length){ alert("가져올 리스가 없습니다. (자산명이 비어있는 행은 건너뜁니다.)"); input.value=""; return; }
    const L=lsLoad();
    arr.forEach(x=>{ const ix=L.findIndex(y=>y.name===x.name); if(ix>=0) L[ix]=x; else L.push(x); });
    lsSave(L); renderLeaseList();
    let msg=`${arr.length}건 가져오기 완료 (같은 자산명은 덮어씀)`;
    if(info){
      if(info.auto) msg+=`\n- 할인율 ${info.auto}건: 신용등급 ${info.rating} 기준 내장 YTM에서 자동 산출`;
      if(info.manual.length) msg+=`\n- ${info.manual.length}건은 자동 산출 불가(개시일이 내장표 범위 밖 또는 등급 데이터 없음) → 할인율 직접 입력 필요:\n  ${info.manual.slice(0,8).join(", ")}${info.manual.length>8?" 외":""}`;
    }
    alert(msg);
  }catch(e){
    alert("가져오기 실패: 리스 목록 엑셀(.xlsx) 형식이 아니거나 손상되었습니다.\n["+((e&&e.message)||e)+"]");
  }
  input.value="";
}

/* 누계 발생액 (개시일~report) — 기간 발생분 = 기간말 누계 − 기간개시 전일 누계 */
function cumOf(m){
  const {rows,complete,partial,inp,settleDate}=m;
  const s=k=>rows.slice(0,complete).reduce((a,r)=>a+r[k],0);
  let pay=0;
  const sd=settleDate||inp.report;   // 해지 리스는 해지일까지 지급분만 (buildJournal과 동일)
  rows.forEach((r,ix)=>{ if(r.payDate<=sd && !(inp.timing==="due"&&ix===0)) pay+=r.pay; });
  return { int:s("interest")+(partial?partial.interest:0),
           dep:s("dep")+(partial?partial.dep:0),
           depInt:s("depInt")+(partial?partial.depInt:0), pay };
}
/* 보고기간말 잔액 (view()의 KPI 산식과 동일) */
function balOf(m){
  const {rows,complete,partial,liability0,cur0,rou,depositPV,inp}=m;
  const liab=(complete?rows[complete-1].end:liability0)+(partial?partial.interest:0);
  const cur=Math.min(complete?rows[complete-1].cur:cur0, liab);
  const cumDep=rows.slice(0,complete).reduce((s,r)=>s+r.dep,0)+(partial?partial.dep:0);
  const cumDepInt=rows.slice(0,complete).reduce((s,r)=>s+r.depInt,0)+(partial?partial.depInt:0);
  return { liab, cur, noncur:liab-cur, rou, bookROU:rou-cumDep, cumDep,
           depBal:inp.deposit>0?depositPV+cumDepInt:0 };
}

function runTotal(){
  const g=id=>document.getElementById(id);
  const err=msg=>{ g("outT").innerHTML=`<div class="note">${msg}</div>`; };
  const ps=parseDate(g("pStart").value), pe=parseDate(g("pEnd").value);
  if(isNaN(ps.getTime())||isNaN(pe.getTime())){ err("회계기간시작일/회계기간종료일을 YYYY-MM-DD 형식으로 입력하세요."); return; }
  if(pe<ps){ err("회계기간종료일이 회계기간시작일보다 빠릅니다."); return; }
  const L=lsLoad();
  if(!L.length){ err("저장된 리스가 없습니다. ① 탭에서 리스를 입력하고 <b>리스 목록에 저장</b>을 먼저 눌러주세요."); return; }
  const items=[], bad=[]; let excluded=0;
  for(const lz of L){
    const inp=buildInp(id=>lz.f[id]);
    if(isNaN(inp.start.getTime())||!(inp.termMonths>=1)||!(inp.payment>0)||!(inp.annualRate>=0)||lz.f.rate===""||lz.f.rate==null){ bad.push(lz.name); continue; }
    if(inp.start>pe){ excluded++; continue; }        // 기간 이후 개시
    inp.report=pe;
    const mEnd=calc(inp);
    const effEnd = mEnd.term ? mEnd.term.date : mEnd.endDate;
    if(effEnd<ps){ excluded++; continue; }           // 기간 이전 종료/해지
    const startedIn=inp.start>=ps, term=mEnd.term;
    const mPrev = startedIn ? null : calc({...inp,report:addDays(ps,-1)});
    const cEnd=cumOf(mEnd);
    const cPrev = mPrev ? cumOf(mPrev) : {int:0,dep:0,depInt:0,pay:0};
    const bPrev = mPrev ? balOf(mPrev) : {bookROU:0,liab:0};
    items.push({ name:lz.name, type:normType(lz.f.assetType), mEnd, openIn:startedIn, rate:inp.annualRate,
      pay:cEnd.pay-cPrev.pay, int:cEnd.int-cPrev.int, dep:cEnd.dep-cPrev.dep, depInt:cEnd.depInt-cPrev.depInt,
      begROU:bPrev.bookROU,                                    // 기초 사용권자산 장부금액
      addROU:startedIn?mEnd.rou:0,                             // 당기 취득(신규 리스 최초인식)
      remROU:term?term.rouBook:0, remLiab:term?term.liab:0,    // 당기 해지 제거(장부금액)
      begLiab:bPrev.liab,                                      // 기초 리스부채
      incLiab:startedIn?mEnd.liability0:0,                     // 당기 증가(신규 리스 최초인식 부채) / 상환은 pay와 동일(분개·잔액과 같은 관례)
      bEnd: term ? {liab:0,cur:0,noncur:0,rou:0,bookROU:0,cumDep:0,depBal:0} : balOf(mEnd),   // 해지 리스는 기말 잔액 0 (제거됨)
      mat: matYears(mEnd,pe) });                               // 연도별 미할인 리스료 [+1y..+4y, 이후]
  }
  LASTT={ps,pe,items,excluded};
  let html=viewTotal(LASTT);
  if(bad.length) html=`<div class="note">입력값이 불완전해 제외된 리스: ${bad.map(_xE).join(", ")}</div>`+html;
  g("outT").innerHTML=html;
}

/* ── 주석검토용: 기말 이후 미래 리스료(할인 전) → 연도별 상환계획 (기말+1년 ~ +4년 / 5년차 이후) ── */
function matYears(m, asOf){
  const y=[0,0,0,0,0];
  if(m.term) return y;                                // 해지 리스 = 미래 지급 없음
  m.rows.forEach((r,ix)=>{
    if(m.inp.timing==="due"&&ix===0) return;          // 선급 1회차(개시일 지급)는 과거분
    if(r.payDate>asOf){
      const d=r.payDate.getFullYear()-asOf.getFullYear();
      y[Math.min(Math.max(d,1),5)-1]+=r.pay;          // 지급일 달력연도 기준 (기말+5년 이상은 '이후')
    }
  });
  return y;
}
/* 종합 분개 (step1: 기중 개시 인식 / step3: 당기 발생분 합산 / step4: 기중 해지 정산) — 화면/엑셀 공유 */
function totalJournal(t){
  const E=[];
  t.items.forEach(it=>{
    if(it.openIn) buildJournal(it.mEnd).filter(e=>e.step===1)
      .forEach(e=>E.push({step:1,date:e.date,memo:`[${it.name}] ${e.memo}`,lines:e.lines}));
  });
  const S=k=>t.items.reduce((s,x)=>s+x[k],0);
  if(S("pay")>0) E.push({step:3,date:t.pe,memo:"리스료 지급액 (전체 리스)",lines:[{side:"dr",acc:"리스부채",amt:S("pay")},{side:"cr",acc:"현금",amt:S("pay")}]});
  if(S("int")>0) E.push({step:3,date:t.pe,memo:"리스부채 이자비용 (전체 리스)",lines:[{side:"dr",acc:"이자비용",amt:S("int")},{side:"cr",acc:"리스부채",amt:S("int")}]});
  if(S("dep")>0) E.push({step:3,date:t.pe,memo:"사용권자산 감가상각비 (전체 리스)",lines:[{side:"dr",acc:"감가상각비",amt:S("dep")},{side:"cr",acc:"감가상각누계액",amt:S("dep")}]});
  if(S("depInt")>0) E.push({step:3,date:t.pe,memo:"임차보증금 이자수익 (전체 리스)",lines:[{side:"dr",acc:"임차보증금",amt:S("depInt")},{side:"cr",acc:"이자수익",amt:S("depInt")}]});
  t.items.forEach(it=>{                              // 기중 해지 리스: 제거/정산 분개 (리스별)
    if(it.mEnd.term) buildJournal(it.mEnd).filter(e=>e.step===4)
      .forEach(e=>E.push({step:4,date:e.date,memo:`[${it.name}] ${e.memo}`,lines:e.lines}));
  });
  return E;
}

function viewTotal(t){
  const {ps,pe,items,excluded}=t;
  const period=`${fmtDate(ps)} ~ ${fmtDate(pe)}`;
  if(!items.length) return `<div class="note">결산기간(${period})과 겹치는 리스가 없습니다.</div>`;
  const S=k=>items.reduce((s,x)=>s+x[k],0);
  const B=items.map(x=>x.bEnd);                    // 해지 리스는 기말 잔액 0 (runTotal에서 결정)
  const SB=k=>B.reduce((s,b)=>s+b[k],0);
  const anyDep=items.some(x=>x.mEnd.inp.deposit>0);
  let html=`<div class="sec"><div class="kpis">
    <div class="kpi"><div class="k">대상 리스</div><div class="v">${items.length}건</div></div>
    <div class="kpi"><div class="k">기말 리스부채 합계</div><div class="v b">${won(SB("liab"))}</div></div>
    <div class="kpi"><div class="k">기말 사용권자산 장부금액</div><div class="v b">${won(SB("bookROU"))}</div></div>
  </div></div>`;
  html+=`<div class="sec"><h3><span class="tag">요약</span>재무제표 표시 합계 (${period})</h3>
    <div class="scroll"><table><thead><tr><th>구분</th><th>금액</th><th>비고</th></tr></thead><tbody>
      <tr><td>사용권자산(취득원가 합계)</td><td>${won(SB("rou"))}</td><td>-</td></tr>
      <tr><td>(−) 감가상각누계액</td><td>${won(SB("cumDep"))}</td><td>-</td></tr>
      <tr><td><b>사용권자산 장부금액</b></td><td><b>${won(SB("bookROU"))}</b></td><td>재무상태표(비유동자산)</td></tr>
      <tr><td><b>리스부채(유동)</b></td><td><b>${won(SB("cur"))}</b></td><td>향후 12개월 지급분 PV</td></tr>
      <tr><td><b>리스부채(비유동)</b></td><td><b>${won(SB("noncur"))}</b></td><td>잔액 − 유동</td></tr>
      ${anyDep?`<tr><td>임차보증금 장부금액</td><td>${won(SB("depBal"))}</td><td>현재가치 + 이자수익 누계</td></tr>`:""}
      <tr><td>당기 이자비용</td><td>${won(S("int"))}</td><td>포괄손익계산서(금융원가)</td></tr>
      <tr><td>당기 감가상각비</td><td>${won(S("dep"))}</td><td>포괄손익계산서(영업비용)</td></tr>
      ${anyDep?`<tr><td>당기 이자수익(보증금)</td><td>${won(S("depInt"))}</td><td>포괄손익계산서(금융수익)</td></tr>`:""}
    </tbody></table></div></div>`;
  const TE=totalJournal(t);
  const s1=TE.filter(e=>e.step===1), s3=TE.filter(e=>e.step===3), s4=TE.filter(e=>e.step===4);
  html+=`<div class="sec"><h3><span class="tag">STEP 1</span>기중 개시 리스 인식</h3>`;
  if(s1.length) s1.forEach(e=> html+=jeBlock(fmtDate(e.date), e.memo, e.lines));
  else html+=`<div class="note">결산기간 중 새로 개시된 리스가 없습니다.</div>`;
  html+=`</div>`;
  html+=`<div class="sec"><h3><span class="tag">STEP 2</span>결산 합산 분개 <span class="badge">당기 발생분 / 전체 리스 / ${fmtDate(pe)}</span></h3>`;
  if(s3.length) s3.forEach(e=> html+=jeBlock(fmtDate(e.date), e.memo, e.lines));
  else html+=`<div class="note">결산기간에 인식할 회계처리가 없습니다.</div>`;
  html+=`</div>`;
  if(s4.length){
    html+=`<div class="sec"><h3><span class="tag">STEP 3</span>기중 해지 리스 정산</h3>`;
    s4.forEach(e=> html+=jeBlock(fmtDate(e.date), e.memo, e.lines));
    html+=`</div>`;
  }
  html+=`<div class="sec"><div class="note">리스별 상세(당기 발생분/기말 잔액)/상각표/<b>주석검토</b>는 <b>종합결산 엑셀(.xlsx)</b>에 시트로 첨부됩니다.${excluded?` / 결산기간과 겹치지 않는 리스 ${excluded}건은 제외되었습니다.`:""}</div></div>`;
  return html;
}

/* ── 리스별 요약 시트 XML ──
   열: B자산명 C기초자산유형 D개시일 E종료일 F당기지급 G당기이자 H당기감가 I기말부채 J유동 K비유동(수식)
       L기말사용권자산 M기초사용권자산 N당기취득 O당기해지제거 P~T미할인리스료(1~4년차/이후)
       U기초리스부채 V당기증가리스부채 W당기해지제거리스부채 X중도해지일 [Y보증금이자 Z기말보증금]
   주석검토가 참조하는 C~W열은 고정 (중도해지일/보증금은 뒤에 붙여 참조 불변). 열 위치 변경 시 SUMMARY_* 상수, 주석검토 참조, 검증스크립트 함께 수정. */
const SUMMARY_FIRST=6;   // 데이터 시작 행
function _summarySheetXML(t){
  const {ps,pe,items}=t;
  const B=items.map(x=>x.bEnd);                           // 해지 리스 = 기말 잔액 0
  const anyDep=items.some(x=>x.mEnd.inp.deposit>0);
  const yr=pe.getFullYear();
  const R2=[];                                            // A열=여백, 내용은 B열부터
  R2.push([]);                                            // 1행: 여백 (높이 13.5)
  R2.push([null,T("[ 리스별 요약 ]",4)]);                  // 2행: 제목
  R2.push([null,T(`결산기간 ${fmtDate(ps)} ~ ${fmtDate(pe)}`,0)]); // 3행: 결산기간
  R2.push([]);                                            // 4행: 여백
  const anyTerm=items.some(x=>x.mEnd.term);                // 중도해지 리스가 하나라도 있으면 열 표시
  const hd=["자산명","기초자산유형","리스개시일","리스종료일","당기 리스료지급","당기 이자비용","당기 감가상각비","기말 리스부채","기말 유동리스부채","기말 비유동리스부채","기말 사용권자산 장부금액","기초 사용권자산 장부금액","당기 취득 사용권자산","당기 해지제거 사용권자산",`미할인리스료 ${yr+1}년`,`미할인리스료 ${yr+2}년`,`미할인리스료 ${yr+3}년`,`미할인리스료 ${yr+4}년`,`미할인리스료 ${yr+5}년 이후`,"기초 리스부채","당기 증가 리스부채","당기 해지제거 리스부채"];
  if(anyTerm) hd.push("중도해지일");
  if(anyDep) hd.push("당기 보증금 이자수익","기말 임차보증금");
  R2.push([null,...hd.map(h=>T(h,1))]);                    // 5행: 머리글
  const FIRST=SUMMARY_FIRST, LAST=FIRST+items.length-1;    // 리스 데이터=6행~ / 합계행=그 다음
  items.forEach((x,ix)=>{ const b=B[ix], m=x.mEnd, r=FIRST+ix;
    const row=[T(x.name),T(x.type),Dt(m.inp.start),Dt(m.endDate),N(x.pay),N(x.int),N(x.dep),N(b.liab),N(b.cur),F(`I${r}-J${r}`,b.noncur),N(b.bookROU),N(x.begROU),N(x.addROU),N(x.remROU),...x.mat.map(v=>N(v)),N(x.begLiab),N(x.incLiab),N(x.remLiab)];  // 비유동 = 기말부채−유동 (수식)
    if(anyTerm) row.push(m.term?Dt(m.term.date):E());
    if(anyDep) row.push(N(x.depInt),N(b.depBal));
    R2.push([null,...row]);
  });
  const S=k=>items.reduce((s,x)=>s+x[k],0), SB=k=>B.reduce((s,b)=>s+b[k],0);
  const SM=i2=>items.reduce((s,x)=>s+x.mat[i2],0);
  const sum=(col,v)=>F(`SUM(${col}${FIRST}:${col}${LAST})`, v, 11);   // 합계 = 열 SUM (수식)
  const tot=[T("합계",10),T("",10),T("",10),T("",10),sum("F",S("pay")),sum("G",S("int")),sum("H",S("dep")),sum("I",SB("liab")),sum("J",SB("cur")),sum("K",SB("noncur")),sum("L",SB("bookROU")),sum("M",S("begROU")),sum("N",S("addROU")),sum("O",S("remROU")),sum("P",SM(0)),sum("Q",SM(1)),sum("R",SM(2)),sum("S",SM(3)),sum("T",SM(4)),sum("U",S("begLiab")),sum("V",S("incLiab")),sum("W",S("remLiab"))];
  const dc1=anyTerm?"Y":"X", dc2=anyTerm?"Z":"Y";          // 보증금 열은 중도해지일 유무에 따라 X/Y 또는 Y/Z
  if(anyTerm) tot.push(T("",10));                          // 중도해지일 열은 합계 없음
  if(anyDep) tot.push(sum(dc1,S("depInt")),sum(dc2,SB("depBal")));
  R2.push([null,...tot]);
  return _mkSheet(R2, `<cols><col min="1" max="1" width="1.43"/><col min="2" max="2" width="20"/><col min="3" max="3" width="14"/><col min="4" max="5" width="13"/><col min="6" max="${hd.length+1}" width="17"/></cols>`, null, null, null, {1:13.5});
}

/* ── 주석검토 시트 XML (K-IFRS 1116 문단 53 정량 공시 / 감사보고서 주석 양식 레이아웃) ──
   모든 산출값은 '리스별요약' 시트를 SUMIF/셀참조 수식으로 집계 (회계사 검증용).
   단기/소액/변동리스료는 툴이 알 수 없어 노란색 빈 셀(직접 입력) — 총 현금유출에 자동 합산.
   주석 번호(15.)는 회사 주석 체계에 맞게 직접 수정. */
function _noteReviewSheetXML(t){
  const {ps,pe,items}=t;
  const yr=pe.getFullYear();
  const FIRST=SUMMARY_FIRST, LAST=FIRST+items.length-1, TOT=LAST+1;   // 리스별요약 데이터/합계 행
  const SR="'리스별요약'!";
  const sif=(col,tp)=>`SUMIF(${SR}$C$${FIRST}:$C$${LAST},"${tp}",${SR}$${col}$${FIRST}:$${col}$${LAST})`;
  // JS 캐시값 (fullCalcOnLoad로 열 때 재계산되지만, 캐시도 엔진값과 일치시킴)
  const byType=f=>ASSET_TYPES.map(tp=>items.filter(x=>x.type===tp).reduce((s,x)=>s+f(x),0));
  const endT=byType(x=>x.bEnd.bookROU), begT=byType(x=>x.begROU), addT=byType(x=>x.addROU),
        depT=byType(x=>x.dep), remT=byType(x=>x.remROU);
  const S=k=>items.reduce((s,x)=>s+(x[k]||0),0);
  const liab=items.reduce((s,x)=>s+x.bEnd.liab,0), cur=items.reduce((s,x)=>s+x.bEnd.cur,0);
  const endTot=endT.reduce((a,b)=>a+b,0);
  const SM=i2=>items.reduce((s,x)=>s+x.mat[i2],0);
  const R2=[], rn=()=>R2.length+1;                     // rn() = 다음에 push될 행 번호
  R2.push([]);                                          // 1행: 여백
  R2.push([null,T("15. 리스",4)]);
  R2.push([null,T("(1) 리스이용자",4)]);
  R2.push([null,T("① 당기 중 리스와 관련해 재무상태표에 인식된 금액은 다음과 같습니다.",0)]);
  R2.push([]);
  R2.push([null,T("구 분",1),T("당기말",1)]);
  R2.push([null,T("사용권자산",10),T("",10)]);
  const rouA=rn();
  ASSET_TYPES.forEach((tp,ix)=>R2.push([null,T(tp),F(sif("L",tp),endT[ix])]));
  R2.push([null,T("합계",10),F(`SUM(C${rouA}:C${rouA+5})`,endTot,11)]);
  R2.push([]);
  R2.push([null,T("구 분",1),T("당기말",1)]);
  R2.push([null,T("리스부채",10),T("",10)]);
  const liA=rn();
  R2.push([null,T("유동"),F(`${SR}J${TOT}`,cur)]);
  R2.push([null,T("비유동"),F(`${SR}K${TOT}`,liab-cur)]);
  R2.push([null,T("합계",10),F(`SUM(C${liA}:C${liA+1})`,liab,11)]);
  R2.push([]);
  // ② 사용권자산 변동내역 (행=유형 / 열=변동)
  R2.push([null,T("② 당기 중 사용권자산 장부금액의 변동내역은 다음과 같습니다.",0)]);
  R2.push([]);
  R2.push([null,T("1) 당기",0)]);
  R2.push([null,T("구분",1),T("기초",1),T("취득",1),T("처분",1),T("감가상각",1),T("기말",1)]);
  const mvA=rn();
  ASSET_TYPES.forEach((tp,ix)=>{ const r=rn();
    R2.push([null,T(tp),F(sif("M",tp),begT[ix]),F(sif("N",tp),addT[ix]),F("-"+sif("O",tp),-remT[ix]),F("-"+sif("H",tp),-depT[ix]),F(`SUM(C${r}:F${r})`,begT[ix]+addT[ix]-remT[ix]-depT[ix])]); });
  { const r=rn(), cv=[S("begROU"),S("addROU"),-S("remROU"),-S("dep"),endTot];
    R2.push([null,T("합계",10),...["C","D","E","F","G"].map((cl,ix)=>F(`SUM(${cl}${mvA}:${cl}${r-1})`, cv[ix], 11))]); }
  R2.push([]);
  // ③ 리스부채 변동내역
  R2.push([null,T("③ 당기 리스 계약과 관련된 리스부채의 변동 내역은 다음과 같습니다.",0)]);
  R2.push([]);
  R2.push([null,T("1) 당기",0)]);
  R2.push([null,T("구분",1),T("기초",1),T("증가",1),T("이자비용",1),T("상환",1),T("해지",1),T("기말",1)]);
  { const r=rn();
    R2.push([null,T("리스부채"),F(`${SR}U${TOT}`,S("begLiab")),F(`${SR}V${TOT}`,S("incLiab")),F(`${SR}G${TOT}`,S("int")),F(`-${SR}F${TOT}`,-S("pay")),F(`-${SR}W${TOT}`,-S("remLiab")),F(`SUM(C${r}:G${r})`,liab)]); }
  R2.push([]);
  // ④ 손익으로 인식한 금액
  R2.push([null,T("④ 당기 중 리스와 관련하여 손익으로 인식한 금액은 다음과 같습니다.",0)]);
  R2.push([]);
  R2.push([null,T("구 분",1),T("당기",1)]);
  R2.push([null,T("사용권자산의 감가상각비",10),T("",10)]);
  const depA=rn();
  ASSET_TYPES.forEach((tp,ix)=>R2.push([null,T("  "+tp),F(sif("H",tp),depT[ix])]));   // 들여쓰기 (샘플 양식)
  R2.push([null,T("합계",10),F(`SUM(C${depA}:C${depA+5})`,S("dep"),11)]);
  R2.push([null,T("리스부채에 대한 이자비용(금융원가에 포함)"),F(`${SR}G${TOT}`,S("int"))]);
  const ylA=rn();
  R2.push([null,T("단기리스료(매출원가 및 관리비에 포함)"),Y()]);
  R2.push([null,T("단기리스가 아닌 소액자산 리스료(관리비에 포함)"),Y()]);
  R2.push([null,T("리스부채 측정치에 포함되지 않은 변동리스료(관리비에 포함)"),Y()]);
  R2.push([null,T("리스의 총 현금유출",10),F(`${SR}F${TOT}+SUM(C${ylA}:C${ylA+2})`,S("pay"),11)]);
  R2.push([null,T("* 노란색 셀(단기/소액/변동리스료)은 툴이 산출할 수 없어 직접 입력하는 항목입니다 (총 현금유출에 자동 합산).",0)]);
  R2.push([]);
  // ⑤ 연도별 상환계획 (할인 전)
  R2.push([null,T("⑤ 보고기간종료일 현재 리스부채의 연도별 상환계획은 다음과 같습니다.",0)]);
  R2.push([]);
  R2.push([null,T("상환연도",1),T("금 액",1)]);
  const myA=rn();
  ["P","Q","R","S","T"].forEach((cl,ix)=>{
    R2.push([null,T(ix<4?`${yr+1+ix}년`:`${yr+5}년 이후`),F(`${SR}${cl}${TOT}`,SM(ix))]);
  });
  R2.push([null,T("계",10),F(`SUM(C${myA}:C${myA+4})`,SM(0)+SM(1)+SM(2)+SM(3)+SM(4),11)]);
  if(!(pe.getMonth()===11&&pe.getDate()===31))   // 12월 말 결산이 아니면 안내 (연도 버킷이 달력연도 기준)
    R2.push([null,T("* 연도는 달력연도 기준입니다. 12월 말 결산이 아닌 경우 첫 해 금액에 당기 잔여 리스료가 포함됩니다.",0)]);
  return _mkSheet(R2, `<cols><col min="1" max="1" width="1.43"/><col min="2" max="2" width="44"/><col min="3" max="9" width="15"/></cols>`, null, null, null, {1:13.5});
}

function exportTotalXLSX(){
  if(!LASTT||!LASTT.items.length){ alert("먼저 종합 결산을 생성하세요."); return; }
  const sheets=[
    {name:"종합분개",xml:_journalSheetXML(totalJournal(LASTT))},
    {name:"리스별요약",xml:_summarySheetXML(LASTT)},
    {name:"주석검토",xml:_noteReviewSheetXML(LASTT)},
  ];
  const used=new Set(sheets.map(s=>s.name));
  LASTT.items.forEach(it=>{               // 시트명: 31자 제한/금지문자 제거/중복 시 _n
    const base=(it.name||"리스").replace(/[\\\/\?\*\[\]:]/g,"").slice(0,25)||"리스";
    let nm=base, k=1;
    while(used.has(nm)) nm=`${base}_${++k}`;
    used.add(nm);
    sheets.push({name:nm,xml:_amortSheetXML(it.mEnd)});
  });
  _saveWB(`리스종합결산_${document.getElementById("pEnd").value}.xlsx`,sheets);
}

renderLeaseList();
if(localStorage.getItem(GUIDE_KEY)) hideGuide();   // 이전에 접었으면 안내 숨김
/* 열었을 때는 빈 상태 — 입력 후 '회계처리 생성'을 눌러야 계산 */

/* ── HTML 속성 핸들러(onclick= 등)를 data-click / data-change / data-input 위임으로 옮김 ──
   모듈은 전역 함수를 노출하지 않으므로 속성에서 직접 부를 수 없다. 값은 "함수" 또는 "함수:인자".
   렌더된 마크업(리스 목록의 열기/삭제)도 같은 방식이라 렌더 뒤 다시 연결할 필요가 없다. */
const ACTIONS = {
  showTab, showGuide, hideGuide, pickDate, syncDate, ydModeChange, applyHistDate, loadRating, interp,
  run, saveLease, exportXLSX, exportLeaseTemplate, clearAllLeases, exportLeasesXLSX, runTotal, exportTotalXLSX,
  loadLease, delLease, clampDay, importLeasesXLSX,
  clickEl: (id) => document.getElementById(id).click(),
};
const NO_ARG = new Set(['showGuide','hideGuide','ydModeChange','applyHistDate','loadRating','interp','run','saveLease',
  'exportXLSX','exportLeaseTemplate','clearAllLeases','exportLeasesXLSX','runTotal','exportTotalXLSX']);
const EL_ARG = new Set(['clampDay','importLeasesXLSX']);      // 원래 (this)를 받던 함수
function dispatch(type, e) {
  const el = e.target.closest(`[data-${type}]`); if (!el) return;
  const [name, arg] = el.dataset[type].split(':');
  const fn = ACTIONS[name]; if (!fn) return;
  if (NO_ARG.has(name)) return fn();
  if (EL_ARG.has(name)) return fn(el);
  return fn(/^\d+$/.test(arg) ? Number(arg) : arg);        // loadLease(${ix}) 는 숫자였다
}
document.addEventListener('click',  e => dispatch('click',  e));
document.addEventListener('change', e => dispatch('change', e));
document.addEventListener('input',  e => dispatch('input',  e));

/* tests.html 이 iframe 으로 이 페이지를 띄워 순수 함수를 검증한다. 검증 대상만 명시적으로 노출. */
Object.assign(window, { buildInp, calc });
